import * as React from 'react';
import { SVGProps } from 'react';

export * from './cadroom';

export const StoryEmptyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='88'
    height='98'
    viewBox='0 0 88 98'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M44 86.7298C68.3005 86.7298 88 67.3147 88 43.3649C88 19.4151 68.3005 0 44 0C19.6995 0 0 19.4151 0 43.3649C0 67.3147 19.6995 86.7298 44 86.7298Z'
      fill='#D8D8D8'
    />
    <path
      d='M44 43.8564H78.5714V94.9279H44V43.8564Z'
      fill='white'
      stroke='black'
      strokeWidth='4.71429'
    />
    <path
      d='M9.42847 43.8564H43.9999V94.9279H9.42847V43.8564Z'
      fill='white'
      stroke='black'
      strokeWidth='4.71429'
    />
    <line
      x1='51.0715'
      y1='55.6419'
      x2='71.5001'
      y2='55.6419'
      stroke='black'
      strokeWidth='4.71429'
    />
    <line
      x1='51.0715'
      y1='66.6419'
      x2='71.5001'
      y2='66.6419'
      stroke='black'
      strokeWidth='4.71429'
    />
    <line
      x1='51.0715'
      y1='77.6419'
      x2='71.5001'
      y2='77.6419'
      stroke='black'
      strokeWidth='4.71429'
    />
    <line
      x1='16.5'
      y1='55.6419'
      x2='36.9286'
      y2='55.6419'
      stroke='black'
      strokeWidth='4.71429'
    />
    <line
      x1='16.5'
      y1='66.6419'
      x2='36.9286'
      y2='66.6419'
      stroke='black'
      strokeWidth='4.71429'
    />
    <line
      x1='16.5'
      y1='77.6419'
      x2='36.9286'
      y2='77.6419'
      stroke='black'
      strokeWidth='4.71429'
    />
  </svg>
);

export const RFQEmptyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='88'
    height='96'
    viewBox='0 0 88 96'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M44 88.5111C68.3005 88.5111 88 68.8113 88 44.5105C88 20.2097 68.3005 0.51001 44 0.51001C19.6995 0.51001 0 20.2097 0 44.5105C0 68.8113 19.6995 88.5111 44 88.5111Z'
      fill='#D8D8D8'
    />
    <path
      d='M75.4627 93.2644V49.1973L50.8131 63.8861L51.6573 46.3268L26.6691 63.8861V41.2622H13.1611V93.2644H75.4627Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M29.7679 38.9119H10.8848V95.5614H77.8342V42.1476L53.801 58.0119V42.1476L29.7679 58.0119V38.9119ZM16.0347 90.4114V44.0618H24.618V67.5821L48.6511 51.7179V67.5821L72.6842 51.7179V90.4114H62.3841V71.5281H46.9342V90.4114H16.0347ZM52.0842 90.4114H57.2341V76.678H52.0842V90.4114Z'
      fill='black'
    />
    <path
      d='M10.8848 38.9119V38.519H10.4919V38.9119H10.8848ZM29.7679 38.9119H30.1608V38.519H29.7679V38.9119ZM10.8848 95.5614H10.4919V95.9542H10.8848V95.5614ZM77.8342 95.5614V95.9542H78.227V95.5614H77.8342ZM77.8342 42.1476H78.227V41.4176L77.6177 41.8198L77.8342 42.1476ZM53.801 58.0119H53.4082V58.7419L54.0175 58.3397L53.801 58.0119ZM53.801 42.1476H54.1939V41.4176L53.5846 41.8198L53.801 42.1476ZM29.7679 58.0119H29.3751V58.7419L29.9844 58.3397L29.7679 58.0119ZM16.0347 44.0618V43.669H15.6419V44.0618H16.0347ZM16.0347 90.4114H15.6419V90.8043H16.0347V90.4114ZM24.618 44.0618H25.0108V43.669H24.618V44.0618ZM24.618 67.5821H24.2251V68.3122L24.8344 67.91L24.618 67.5821ZM48.6511 51.7179H49.0439V50.9878L48.4347 51.39L48.6511 51.7179ZM48.6511 67.5821H48.2582V68.3122L48.8675 67.91L48.6511 67.5821ZM72.6842 51.7179H73.0771V50.9878L72.4678 51.39L72.6842 51.7179ZM72.6842 90.4114V90.8043H73.0771V90.4114H72.6842ZM62.3841 90.4114H61.9912V90.8043H62.3841V90.4114ZM62.3841 71.5281H62.7769V71.1352H62.3841V71.5281ZM46.9342 71.5281V71.1352H46.5413V71.5281H46.9342ZM46.9342 90.4114V90.8043H47.3271V90.4114H46.9342ZM52.0842 90.4114H51.6913V90.8043H52.0842V90.4114ZM57.2341 90.4114V90.8043H57.627V90.4114H57.2341ZM57.2341 76.678H57.627V76.2852H57.2341V76.678ZM52.0842 76.678V76.2852H51.6913V76.678H52.0842ZM10.8848 39.3047H29.7679V38.519H10.8848V39.3047ZM11.2776 95.5614V38.9119H10.4919V95.5614H11.2776ZM77.8342 95.1685H10.8848V95.9542H77.8342V95.1685ZM77.4413 42.1476V95.5614H78.227V42.1476H77.4413ZM54.0175 58.3397L78.0506 42.4755L77.6177 41.8198L53.5846 57.684L54.0175 58.3397ZM53.4082 42.1476V58.0119H54.1939V42.1476H53.4082ZM29.9844 58.3397L54.0175 42.4755L53.5846 41.8198L29.5515 57.684L29.9844 58.3397ZM29.3751 38.9119V58.0119H30.1608V38.9119H29.3751ZM15.6419 44.0618V90.4114H16.4276V44.0618H15.6419ZM24.618 43.669H16.0347V44.4547H24.618V43.669ZM25.0108 67.5821V44.0618H24.2251V67.5821H25.0108ZM48.4347 51.39L24.4015 67.2543L24.8344 67.91L48.8675 52.0458L48.4347 51.39ZM49.0439 67.5821V51.7179H48.2582V67.5821H49.0439ZM72.4678 51.39L48.4347 67.2543L48.8675 67.91L72.9006 52.0458L72.4678 51.39ZM73.0771 90.4114V51.7179H72.2913V90.4114H73.0771ZM62.3841 90.8043H72.6842V90.0185H62.3841V90.8043ZM61.9912 71.5281V90.4114H62.7769V71.5281H61.9912ZM46.9342 71.9209H62.3841V71.1352H46.9342V71.9209ZM47.3271 90.4114V71.5281H46.5413V90.4114H47.3271ZM16.0347 90.8043H46.9342V90.0185H16.0347V90.8043ZM52.0842 90.8043H57.2341V90.0185H52.0842V90.8043ZM57.627 90.4114V76.678H56.8413V90.4114H57.627ZM57.2341 76.2852H52.0842V77.0709H57.2341V76.2852ZM51.6913 76.678V90.4114H52.477V76.678H51.6913Z'
      fill='black'
    />
  </svg>
);

export const QuotesEmptyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='89'
    height='98'
    viewBox='0 0 89 98'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M44.5 88C68.8005 88 88.5 68.3005 88.5 44C88.5 19.6995 68.8005 0 44.5 0C20.1995 0 0.5 19.6995 0.5 44C0.5 68.3005 20.1995 88 44.5 88Z'
      fill='#D8D8D8'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M67.2857 31.4297H13.8572V52.644H35.0714V95.0724H75.1429V41.6438H67.2857V31.4297Z'
      fill='white'
    />
    <path
      d='M68.7698 39.28V29.7158H11.3845V53.6264H32.904V96.6654H78.3341V39.28H68.7698ZM16.1666 48.8443V34.4979H63.9877V39.28H32.904V48.8443H16.1666ZM73.5519 91.8832H37.6861V44.0621H73.5519V91.8832Z'
      fill='black'
    />
    <path d='M47.2504 51.2354H42.4683V56.0175H47.2504V51.2354Z' fill='black' />
    <path d='M68.7699 51.2354H52.0325V56.0175H68.7699V51.2354Z' fill='black' />
    <path d='M47.2504 65.582H42.4683V70.3641H47.2504V65.582Z' fill='black' />
    <path d='M68.7699 65.582H52.0325V70.3641H68.7699V65.582Z' fill='black' />
    <path d='M47.2504 79.9277H42.4683V84.7098H47.2504V79.9277Z' fill='black' />
    <path d='M68.7699 79.9277H52.0325V84.7098H68.7699V79.9277Z' fill='black' />
  </svg>
);

export const OrderEmptyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='88'
    height='98'
    viewBox='0 0 88 98'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M44 88.3213C68.3005 88.3213 88 68.6218 88 44.3213C88 20.0208 68.3005 0.321289 44 0.321289C19.6995 0.321289 0 20.0208 0 44.3213C0 68.6218 19.6995 88.3213 44 88.3213Z'
      fill='#D8D8D8'
    />
    <path
      d='M30.531 97.8656C33.1703 97.8656 35.3099 95.726 35.3099 93.0866C35.3099 90.4472 33.1703 88.3076 30.531 88.3076C27.8916 88.3076 25.752 90.4472 25.752 93.0866C25.752 95.726 27.8916 97.8656 30.531 97.8656Z'
      fill='black'
    />
    <path
      d='M63.9841 97.8656C66.6234 97.8656 68.7631 95.726 68.7631 93.0866C68.7631 90.4472 66.6234 88.3076 63.9841 88.3076C61.3447 88.3076 59.2051 90.4472 59.2051 93.0866C59.2051 95.726 61.3447 97.8656 63.9841 97.8656Z'
      fill='black'
    />
    <path
      d='M68.5305 67.1483L73.417 46.7881H19.666L22.9236 67.1483H68.5305Z'
      fill='white'
      stroke='black'
      strokeWidth='0.785714'
    />
    <path
      d='M73.5412 44.4841H20.5421L18.5827 34.4482C18.471 33.9004 18.1707 33.409 17.7341 33.0597C17.2975 32.7105 16.7523 32.5253 16.1932 32.5366H6.63525V37.3156H14.2339L23.3617 83.194C23.4735 83.7418 23.7737 84.2332 24.2104 84.5825C24.647 84.9317 25.1922 85.1169 25.7512 85.1056H68.7622V80.3266H27.7106L25.7512 70.7686H68.7622C69.3146 70.7821 69.8545 70.6038 70.2902 70.2639C70.7259 69.9241 71.0303 69.4438 71.1517 68.9048L75.9307 47.3993C76.0108 47.0448 76.0089 46.6766 75.9253 46.3229C75.8416 45.9692 75.6784 45.6392 75.4479 45.3581C75.2175 45.077 74.926 44.8522 74.5956 44.7007C74.2652 44.5493 73.9046 44.4752 73.5412 44.4841ZM66.8506 65.9896H24.8432L21.4979 49.2631H70.5543L66.8506 65.9896Z'
      fill='black'
      stroke='black'
      strokeWidth='0.785714'
    />
  </svg>
);

export const FileEmptyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='88'
    height='98'
    viewBox='0 0 88 98'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M44 88.2861C68.3005 88.2861 88 68.5867 88 44.2861C88 19.9856 68.3005 0.286133 44 0.286133C19.6995 0.286133 0 19.9856 0 44.2861C0 68.5867 19.6995 88.2861 44 88.2861Z'
      fill='#D8D8D8'
    />
    <path
      d='M69.1431 79.8368V50.6881L44.0803 35.6436L18.0717 50.6881V79.8368L44.0803 93.0007L69.1431 79.8368Z'
      fill='white'
    />
    <path
      d='M44.0894 38.0281L43.8345 37.8802L43.5799 38.0289L24.1974 49.3447L23.4523 49.7797L24.1953 50.2184L43.7475 61.7631L44.0043 61.9148L44.2615 61.7638L63.7653 50.3116L64.5139 49.872L63.7629 49.4365L44.0894 38.0281ZM21.8639 54.4461L21.1023 53.9963L21.0997 54.8808L21.0319 77.9411L21.031 78.2339L21.2843 78.3808L40.8317 89.7161L41.5924 90.1573V89.2779V66.3881V66.099L41.3434 65.9519L21.8639 54.4461ZM46.4031 89.2779V90.1573L47.1639 89.7161L66.7112 78.3808L66.9645 78.234L66.9637 77.9412L66.9007 54.954L66.8982 54.072L66.1376 54.5185L46.6533 65.9561L46.4031 66.1029V66.393V89.2779ZM43.8216 32.3009L71.6832 48.4572L71.7785 81.0173L44.0002 97.1292L16.2219 81.0173L16.3124 48.3588L43.8216 32.3009Z'
      fill='black'
      stroke='black'
      strokeWidth='1.01317'
    />
  </svg>
);

export const SharedFileEmptyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='94'
    height='114'
    viewBox='0 0 94 114'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M47 93.1205C72.6812 93.1205 93.5 72.3018 93.5 46.6206C93.5 20.9393 72.6812 0.120605 47 0.120605C21.3188 0.120605 0.5 20.9393 0.5 46.6206C0.5 72.3018 21.3188 93.1205 47 93.1205Z'
      fill='#D8D8D8'
    />
    <path
      d='M75.8381 93.5357V60.3428L47.4635 43.2109L18.0182 60.3428V93.5357L47.4635 108.526L75.8381 93.5357Z'
      fill='white'
      stroke='black'
      strokeWidth='1.07074'
    />
    <path
      d='M47.0087 46.1323L46.7392 45.976L46.4702 46.1331L24.4588 58.9837L23.6713 59.4434L24.4565 59.9071L46.6607 73.0177L46.9321 73.1779L47.204 73.0183L69.353 60.0128L70.1442 59.5483L69.3505 59.088L47.0087 46.1323ZM21.7684 64.777L20.9635 64.3016L20.9608 65.2364L20.8837 91.4244L20.8828 91.7339L21.1505 91.8891L43.3491 104.762L44.1531 105.228V104.299V78.3043V77.9987L43.89 77.8433L21.7684 64.777ZM49.6962 104.299V105.228L50.5001 104.762L72.6988 91.8891L72.9664 91.7339L72.9656 91.4245L72.894 65.3195L72.8914 64.3874L72.0876 64.8592L49.9605 77.8481L49.6962 78.0033V78.3098V104.299ZM46.7245 39.5476L78.405 57.9184L78.5133 94.9407L46.9274 113.261L15.3414 94.9406L15.4443 57.8067L46.7245 39.5476Z'
      fill='black'
      stroke='black'
      strokeWidth='1.07074'
    />
    <mask
      id='path-4-outside-1_3931_8012'
      maskUnits='userSpaceOnUse'
      x='25.5841'
      y='22.2573'
      width='43'
      height='21'
      fill='black'
    >
      <rect fill='white' x='25.5841' y='22.2573' width='43' height='21' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M49.1947 34.3656L46.9194 32.9659L44.2351 34.5571V23.2573H49.1947V34.3656ZM31.5436 41.7325L35.8387 39.2527L30.8792 30.6626L26.5841 33.1423L31.5436 41.7325ZM62.9764 30.6613L67.2715 33.141L62.312 41.7311L58.0169 39.2514L62.9764 30.6613Z'
      />
    </mask>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M49.1947 34.3656L46.9194 32.9659L44.2351 34.5571V23.2573H49.1947V34.3656ZM31.5436 41.7325L35.8387 39.2527L30.8792 30.6626L26.5841 33.1423L31.5436 41.7325ZM62.9764 30.6613L67.2715 33.141L62.312 41.7311L58.0169 39.2514L62.9764 30.6613Z'
      fill='black'
    />
    <path
      d='M49.1947 34.3656L48.9141 34.8216L49.73 35.3235V34.3656H49.1947ZM46.9194 32.9659L47.1999 32.5099L46.9245 32.3405L46.6464 32.5054L46.9194 32.9659ZM44.2351 34.5571H43.6998V35.4969L44.5081 35.0177L44.2351 34.5571ZM44.2351 23.2573V22.722H43.6998V23.2573H44.2351ZM49.1947 23.2573H49.73V22.722H49.1947V23.2573ZM35.8387 39.2527L36.1064 39.7163L36.57 39.4487L36.3023 38.985L35.8387 39.2527ZM31.5436 41.7325L31.08 42.0001L31.3477 42.4638L31.8113 42.1961L31.5436 41.7325ZM30.8792 30.6626L31.3428 30.3949L31.0751 29.9312L30.6115 30.1989L30.8792 30.6626ZM26.5841 33.1423L26.3164 32.6787L25.8528 32.9464L26.1205 33.41L26.5841 33.1423ZM67.2715 33.141L67.7351 33.4087L68.0028 32.9451L67.5392 32.6774L67.2715 33.141ZM62.9764 30.6613L63.2441 30.1976L62.7805 29.9299L62.5128 30.3936L62.9764 30.6613ZM62.312 41.7311L62.0443 42.1948L62.5079 42.4625L62.7756 41.9988L62.312 41.7311ZM58.0169 39.2514L57.5533 38.9837L57.2856 39.4473L57.7492 39.715L58.0169 39.2514ZM49.4752 33.9096L47.1999 32.5099L46.6389 33.4219L48.9141 34.8216L49.4752 33.9096ZM46.6464 32.5054L43.9621 34.0966L44.5081 35.0177L47.1924 33.4265L46.6464 32.5054ZM44.7705 34.5571V23.2573H43.6998V34.5571H44.7705ZM44.2351 23.7927H49.1947V22.722H44.2351V23.7927ZM48.6593 23.2573V34.3656H49.73V23.2573H48.6593ZM35.571 38.789L31.2759 41.2688L31.8113 42.1961L36.1064 39.7163L35.571 38.789ZM30.4155 30.9302L35.3751 39.5204L36.3023 38.985L31.3428 30.3949L30.4155 30.9302ZM26.8518 33.606L31.1469 31.1262L30.6115 30.1989L26.3164 32.6787L26.8518 33.606ZM32.0073 41.4648L27.0478 32.8746L26.1205 33.41L31.08 42.0001L32.0073 41.4648ZM67.5392 32.6774L63.2441 30.1976L62.7088 31.1249L67.0038 33.6047L67.5392 32.6774ZM62.7756 41.9988L67.7351 33.4087L66.8079 32.8733L61.8483 41.4635L62.7756 41.9988ZM57.7492 39.715L62.0443 42.1948L62.5797 41.2675L58.2846 38.7877L57.7492 39.715ZM62.5128 30.3936L57.5533 38.9837L58.4806 39.5191L63.4401 30.9289L62.5128 30.3936Z'
      fill='black'
      mask='url(#path-4-outside-1_3931_8012)'
    />
  </svg>
);

export const AnnotationEmptyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='57'
    height='69'
    viewBox='0 0 57 69'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M28.5 56C43.964 56 56.5 43.4639 56.5 28C56.5 12.536 43.964 0 28.5 0C13.036 0 0.5 12.536 0.5 28C0.5 43.4639 13.036 56 28.5 56Z'
      fill='#D8D8D8'
    />
    <mask
      id='path-2-outside-1_5562_23489'
      maskUnits='userSpaceOnUse'
      x='15.2065'
      y='14.9319'
      width='26'
      height='13'
      fill='black'
    >
      <rect fill='white' x='15.2065' y='14.9319' width='26' height='13' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M26.8351 24.2334H29.8215V15.9319H26.8351V24.2334ZM21.6464 25.6401L21.7792 25.5634L18.7928 20.3909L16.2065 21.8841L19.0441 26.7988L19.3555 26.6384C20.1021 26.2538 20.8674 25.9211 21.6464 25.6401ZM37.7438 27.0149L37.295 26.7751C37.1097 26.676 36.9231 26.5801 36.7354 26.4875L35.1338 25.5628L38.1202 20.3903L40.7064 21.8835L37.7438 27.0149Z'
      />
    </mask>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M26.8351 24.2334H29.8215V15.9319H26.8351V24.2334ZM21.6464 25.6401L21.7792 25.5634L18.7928 20.3909L16.2065 21.8841L19.0441 26.7988L19.3555 26.6384C20.1021 26.2538 20.8674 25.9211 21.6464 25.6401ZM37.7438 27.0149L37.295 26.7751C37.1097 26.676 36.9231 26.5801 36.7354 26.4875L35.1338 25.5628L38.1202 20.3903L40.7064 21.8835L37.7438 27.0149Z'
      fill='black'
    />
    <path
      d='M29.8215 24.2334V24.5558H30.1438V24.2334H29.8215ZM26.8351 24.2334H26.5127V24.5558H26.8351V24.2334ZM29.8215 15.9319H30.1438V15.6095H29.8215V15.9319ZM26.8351 15.9319V15.6095H26.5127V15.9319H26.8351ZM21.7792 25.5634L21.9404 25.8426L22.2196 25.6814L22.0584 25.4023L21.7792 25.5634ZM21.6464 25.6401L21.7557 25.9434L21.7827 25.9337L21.8075 25.9193L21.6464 25.6401ZM18.7928 20.3909L19.072 20.2297L18.9108 19.9505L18.6316 20.1117L18.7928 20.3909ZM16.2065 21.8841L16.0454 21.6049L15.7662 21.7661L15.9274 22.0453L16.2065 21.8841ZM19.0441 26.7988L18.7649 26.96L18.9185 27.2261L19.1917 27.0854L19.0441 26.7988ZM19.3555 26.6384L19.2079 26.3518H19.2079L19.3555 26.6384ZM37.7438 27.0149L37.5918 27.2992L37.867 27.4463L38.023 27.1761L37.7438 27.0149ZM37.295 26.7751L37.447 26.4908L37.295 26.7751ZM36.7354 26.4875L36.5742 26.7667L36.5833 26.772L36.5928 26.7766L36.7354 26.4875ZM35.1338 25.5628L34.8546 25.4017L34.6934 25.6808L34.9726 25.842L35.1338 25.5628ZM38.1202 20.3903L38.2813 20.1111L38.0022 19.9499L37.841 20.2291L38.1202 20.3903ZM40.7064 21.8835L40.9856 22.0447L41.1468 21.7655L40.8676 21.6043L40.7064 21.8835ZM29.8215 23.9111H26.8351V24.5558H29.8215V23.9111ZM29.4991 15.9319V24.2334H30.1438V15.9319H29.4991ZM26.8351 16.2543H29.8215V15.6095H26.8351V16.2543ZM27.1575 24.2334V15.9319H26.5127V24.2334H27.1575ZM21.618 25.2843L21.4852 25.361L21.8075 25.9193L21.9404 25.8426L21.618 25.2843ZM18.5136 20.5521L21.5 25.7246L22.0584 25.4023L19.072 20.2297L18.5136 20.5521ZM16.3677 22.1633L18.954 20.6701L18.6316 20.1117L16.0454 21.6049L16.3677 22.1633ZM19.3232 26.6376L16.4857 21.7229L15.9274 22.0453L18.7649 26.96L19.3232 26.6376ZM19.2079 26.3518L18.8964 26.5122L19.1917 27.0854L19.5031 26.925L19.2079 26.3518ZM21.537 25.3369C20.745 25.6225 19.9669 25.9608 19.2079 26.3518L19.5031 26.925C20.2373 26.5468 20.9898 26.2197 21.7557 25.9434L21.537 25.3369ZM37.8958 26.7306L37.447 26.4908L37.1431 27.0594L37.5918 27.2992L37.8958 26.7306ZM37.447 26.4908C37.2586 26.39 37.0689 26.2926 36.878 26.1984L36.5928 26.7766C36.7773 26.8677 36.9608 26.962 37.1431 27.0594L37.447 26.4908ZM34.9726 25.842L36.5742 26.7667L36.8966 26.2083L35.295 25.2837L34.9726 25.842ZM37.841 20.2291L34.8546 25.4017L35.413 25.724L38.3993 20.5515L37.841 20.2291ZM40.8676 21.6043L38.2813 20.1111L37.959 20.6695L40.5453 22.1627L40.8676 21.6043ZM38.023 27.1761L40.9856 22.0447L40.4273 21.7223L37.4646 26.8537L38.023 27.1761Z'
      fill='black'
      mask='url(#path-2-outside-1_5562_23489)'
    />
    <path
      d='M45.5 48.0006V48.0009C45.5 57.3881 37.8894 65 28.5 65H11.5V47.9991C11.5 38.6121 19.1123 31 28.5 31C37.8896 31 45.5017 38.6121 45.5 48.0006Z'
      fill='white'
      stroke='black'
      strokeWidth='4'
    />
  </svg>
);

export const ProjectEmptyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='88'
    height='98'
    viewBox='0 0 88 98'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.03571 71.0021V43.1076H29.0714L39.6786 53.3218H81.3214L82.5421 65.5289C86.0204 59.2311 88 51.9901 88 44.2867C88 19.9858 68.3005 0.286133 44 0.286133C19.6995 0.286133 0 19.9858 0 44.2867C0 54.3341 3.36763 63.595 9.03571 71.0021Z'
      fill='#D8D8D8'
    />
    <path
      d='M28.4016 43.1887L36.9429 52.0204L38.3914 53.5485H77.5051V72.5198V91.4912H61.5214H10.4949V43.1887H28.4016ZM28.4016 38.0088H10.4949C9.17017 38.0088 7.8997 38.5545 6.96297 39.5259C6.02625 40.4974 5.5 41.8149 5.5 43.1887V91.4912C5.5 92.865 6.02625 94.1825 6.96297 95.1539C7.8997 96.1254 9.17017 96.6711 10.4949 96.6711H61.5214H77.5051C78.8298 96.6711 80.1003 96.1254 81.037 95.1539C81.9737 94.1825 82.5 92.865 82.5 91.4912V72.5198V53.5485C82.5 52.1747 81.9737 50.8572 81.037 49.8857C80.1003 48.9143 78.8298 48.3686 77.5051 48.3686H40.4643L31.948 39.5369C31.4833 39.0521 30.9307 38.6675 30.3221 38.4053C29.7134 38.143 29.0607 38.0082 28.4016 38.0088Z'
      fill='black'
    />
    <path
      d='M28.4016 43.1887L28.684 42.9156L28.5682 42.7958H28.4016V43.1887ZM36.9429 52.0204L37.228 51.7501L37.2253 51.7473L36.9429 52.0204ZM38.3914 53.5485L38.1063 53.8187L38.2225 53.9413H38.3914V53.5485ZM77.5051 53.5485H77.898V53.1556H77.5051V53.5485ZM77.5051 91.4912V91.8841H77.898V91.4912H77.5051ZM10.4949 91.4912H10.102V91.8841H10.4949V91.4912ZM10.4949 43.1887V42.7958H10.102V43.1887H10.4949ZM28.4016 38.0088V38.4016L28.4019 38.4016L28.4016 38.0088ZM10.4949 38.0088V37.6159V38.0088ZM5.5 43.1887H5.10714H5.5ZM5.5 91.4912H5.10714H5.5ZM77.5051 48.3686V47.9757V48.3686ZM40.4643 48.3686L40.1815 48.6413L40.2974 48.7614H40.4643V48.3686ZM31.948 39.5369L31.6644 39.8087L31.6652 39.8096L31.948 39.5369ZM28.1192 43.4618L36.6605 52.2935L37.2253 51.7473L28.684 42.9156L28.1192 43.4618ZM36.6578 52.2907L38.1063 53.8187L38.6765 53.2782L37.228 51.7501L36.6578 52.2907ZM38.3914 53.9413H77.5051V53.1556H38.3914V53.9413ZM10.8878 91.4912V43.1887H10.102V91.4912H10.8878ZM10.4949 43.5815H28.4016V42.7958H10.4949V43.5815ZM28.4016 37.6159H10.4949V38.4016H28.4016V37.6159ZM10.4949 37.6159C9.06127 37.6159 7.68938 38.2067 6.68018 39.2533L7.24577 39.7986C8.11001 38.9024 9.27907 38.4016 10.4949 38.4016V37.6159ZM6.68018 39.2533C5.67144 40.2993 5.10714 41.7152 5.10714 43.1887H5.89286C5.89286 41.9146 6.38106 40.6954 7.24577 39.7986L6.68018 39.2533ZM5.10714 43.1887V91.4912H5.89286V43.1887H5.10714ZM5.10714 91.4912C5.10714 92.9647 5.67144 94.3805 6.68018 95.4266L7.24577 94.8812C6.38106 93.9845 5.89286 92.7653 5.89286 91.4912H5.10714ZM6.68018 95.4266C7.68938 96.4732 9.06127 97.0639 10.4949 97.0639V96.2782C9.27907 96.2782 8.11001 95.7775 7.24577 94.8812L6.68018 95.4266ZM77.5051 97.0639C78.9387 97.0639 80.3106 96.4732 81.3198 95.4266L80.7542 94.8812C79.89 95.7775 78.7209 96.2782 77.5051 96.2782V97.0639ZM81.3198 95.4266C82.3286 94.3805 82.8929 92.9647 82.8929 91.4912H82.1071C82.1071 92.7653 81.6189 93.9845 80.7542 94.8812L81.3198 95.4266ZM82.8929 53.5485C82.8929 52.075 82.3286 50.6591 81.3198 49.613L80.7542 50.1584C81.6189 51.0552 82.1071 52.2744 82.1071 53.5485H82.8929ZM81.3198 49.613C80.3106 48.5665 78.9387 47.9757 77.5051 47.9757V48.7614C78.7209 48.7614 79.89 49.2622 80.7542 50.1584L81.3198 49.613ZM77.5051 47.9757H40.4643V48.7614H77.5051V47.9757ZM40.7471 48.0959L32.2308 39.2642L31.6652 39.8096L40.1815 48.6413L40.7471 48.0959ZM32.2316 39.265C31.7311 38.7429 31.1351 38.3278 30.4775 38.0445L30.1666 38.766C30.7264 39.0072 31.2356 39.3614 31.6644 39.8087L32.2316 39.265ZM30.4775 38.0445C29.8199 37.7611 29.1143 37.6153 28.4013 37.6159L28.4019 38.4016C29.0072 38.4012 29.6069 38.5249 30.1666 38.766L30.4775 38.0445ZM77.1122 53.5485V72.5198H77.898V53.5485H77.1122ZM77.1122 72.5198V91.4912H77.898V72.5198H77.1122ZM82.8929 91.4912V72.5198H82.1071V91.4912H82.8929ZM82.8929 72.5198V53.5485H82.1071V72.5198H82.8929ZM77.5051 91.0983H61.5214V91.8841H77.5051V91.0983ZM61.5214 91.0983H10.4949V91.8841H61.5214V91.0983ZM10.4949 97.0639H61.5214V96.2782H10.4949V97.0639ZM61.5214 97.0639H77.5051V96.2782H61.5214V97.0639Z'
      fill='black'
    />
  </svg>
);

export const DriveEmptyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='88'
    height='98'
    viewBox='0 0 88 98'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9.03571 70.716V42.8214H29.0714L39.6786 53.0357H81.3214L82.5421 65.2427C86.0204 58.945 88 51.7039 88 44.0005C88 19.6997 68.3005 0 44 0C19.6995 0 0 19.6997 0 44.0005C0 54.048 3.36763 63.3089 9.03571 70.716Z'
      fill='#D8D8D8'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M36.9429 51.7343L28.4016 42.9026H10.4949V91.2051H55.7857V96.385H10.4949C9.17017 96.385 7.8997 95.8392 6.96297 94.8678C6.02625 93.8964 5.5 92.5789 5.5 91.2051V42.9026C5.5 41.5288 6.02625 40.2112 6.96297 39.2398C7.8997 38.2684 9.17017 37.7227 10.4949 37.7227H28.4016C29.0607 37.7221 29.7134 37.8569 30.3221 38.1191C30.9307 38.3814 31.4833 38.766 31.948 39.2507L40.4643 48.0824H77.5051C78.8298 48.0824 80.1003 48.6282 81.037 49.5996C81.9737 50.571 82.5 51.8885 82.5 53.2623V69.1429H77.5051V53.2623H38.3914L36.9429 51.7343Z'
      fill='black'
    />
    <path
      d='M28.4016 42.9026L28.684 42.6294L28.5682 42.5097H28.4016V42.9026ZM36.9429 51.7343L37.228 51.464L37.2253 51.4612L36.9429 51.7343ZM10.4949 42.9026V42.5097H10.102V42.9026H10.4949ZM10.4949 91.2051H10.102V91.5979H10.4949V91.2051ZM55.7857 91.2051H56.1786V90.8122H55.7857V91.2051ZM55.7857 96.385V96.7778H56.1786V96.385H55.7857ZM6.96297 94.8678L6.68018 95.1405H6.68018L6.96297 94.8678ZM6.96297 39.2398L6.68018 38.9671H6.68018L6.96297 39.2398ZM28.4016 37.7227V38.1155L28.4019 38.1155L28.4016 37.7227ZM30.3221 38.1191L30.1666 38.4799V38.4799L30.3221 38.1191ZM31.948 39.2507L31.6644 39.5226L31.6652 39.5234L31.948 39.2507ZM40.4643 48.0824L40.1815 48.3551L40.2974 48.4753H40.4643V48.0824ZM81.037 49.5996L81.3198 49.3269V49.3269L81.037 49.5996ZM82.5 69.1429V69.5357H82.8929V69.1429H82.5ZM77.5051 69.1429H77.1122V69.5357H77.5051V69.1429ZM77.5051 53.2623H77.898V52.8695H77.5051V53.2623ZM38.3914 53.2623L38.1063 53.5326L38.2225 53.6552H38.3914V53.2623ZM28.1192 43.1757L36.6605 52.0074L37.2253 51.4612L28.684 42.6294L28.1192 43.1757ZM10.4949 43.2954H28.4016V42.5097H10.4949V43.2954ZM10.8878 91.2051V42.9026H10.102V91.2051H10.8878ZM55.7857 90.8122H10.4949V91.5979H55.7857V90.8122ZM56.1786 96.385V91.2051H55.3929V96.385H56.1786ZM10.4949 96.7778H55.7857V95.9921H10.4949V96.7778ZM6.68018 95.1405C7.68938 96.1871 9.06127 96.7778 10.4949 96.7778V95.9921C9.27907 95.9921 8.11001 95.4914 7.24577 94.5951L6.68018 95.1405ZM5.10714 91.2051C5.10714 92.6785 5.67144 94.0944 6.68018 95.1405L7.24577 94.5951C6.38106 93.6984 5.89286 92.4792 5.89286 91.2051H5.10714ZM5.10714 42.9026V91.2051H5.89286V42.9026H5.10714ZM6.68018 38.9671C5.67144 40.0132 5.10714 41.4291 5.10714 42.9026H5.89286C5.89286 41.6284 6.38106 40.4092 7.24577 39.5125L6.68018 38.9671ZM10.4949 37.3298C9.06127 37.3298 7.68938 37.9205 6.68018 38.9671L7.24577 39.5125C8.11001 38.6163 9.27907 38.1155 10.4949 38.1155V37.3298ZM28.4016 37.3298H10.4949V38.1155H28.4016V37.3298ZM30.4775 37.7583C29.8199 37.475 29.1143 37.3292 28.4013 37.3298L28.4019 38.1155C29.0072 38.115 29.6069 38.2387 30.1666 38.4799L30.4775 37.7583ZM32.2316 38.9789C31.7311 38.4567 31.1351 38.0416 30.4775 37.7583L30.1666 38.4799C30.7264 38.7211 31.2356 39.0752 31.6644 39.5226L32.2316 38.9789ZM40.7471 47.8097L32.2308 38.978L31.6652 39.5234L40.1815 48.3551L40.7471 47.8097ZM77.5051 47.6896H40.4643V48.4753H77.5051V47.6896ZM81.3198 49.3269C80.3106 48.2803 78.9387 47.6896 77.5051 47.6896V48.4753C78.7209 48.4753 79.89 48.976 80.7542 49.8723L81.3198 49.3269ZM82.8929 53.2623C82.8929 51.7889 82.3286 50.373 81.3198 49.3269L80.7542 49.8723C81.6189 50.769 82.1071 51.9882 82.1071 53.2623H82.8929ZM82.8929 69.1429V53.2623H82.1071V69.1429H82.8929ZM77.5051 69.5357H82.5V68.75H77.5051V69.5357ZM77.1122 53.2623V69.1429H77.898V53.2623H77.1122ZM38.3914 53.6552H77.5051V52.8695H38.3914V53.6552ZM36.6578 52.0045L38.1063 53.5326L38.6765 52.9921L37.228 51.464L36.6578 52.0045Z'
      fill='black'
    />
    <rect x='68.3574' y='73.8564' width='5.5' height='22.7857' fill='black' />
    <rect
      x='59.7148'
      y='87.999'
      width='5.5'
      height='22.7857'
      transform='rotate(-90 59.7148 87.999)'
      fill='black'
    />
  </svg>
);

export const HistoryEmptyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='88'
    height='98'
    viewBox='0 0 88 98'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.8025 77.7796C14.2288 74.1655 13.3571 70.1832 13.3571 66C13.3571 49.5104 26.9005 36.1429 43.6071 36.1429C60.3138 36.1429 73.8571 49.5104 73.8571 66C73.8571 70.5738 72.8152 74.9074 70.9527 78.7822C81.3249 70.7328 88 58.1462 88 44.0005C88 19.6997 68.3005 0 44 0C19.6995 0 0 19.6997 0 44.0005C0 57.5719 6.14414 69.7082 15.8025 77.7796Z'
      fill='#D8D8D8'
    />
    <path
      d='M25.0016 67.2389L17.313 80.556L3.99596 72.8674'
      stroke='black'
      strokeWidth='5.5'
    />
    <path
      d='M44.0007 95.0717C60.4903 95.0717 73.8578 81.7042 73.8578 65.2146C73.8578 48.7249 60.4903 35.3574 44.0007 35.3574C27.5111 35.3574 14.1436 48.7249 14.1436 65.2146C14.1436 69.7909 15.1732 74.1268 17.0134 78.0033'
      stroke='black'
      strokeWidth='5.5'
    />
    <path
      d='M55.7574 80.143L41.6426 66.4883V42.4287H47.2548V64.2276L59.714 76.3024L55.7574 80.143Z'
      fill='black'
    />
  </svg>
);

export const OpenTaskEmptyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='88'
    height='100'
    viewBox='0 0 88 100'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M44 88C68.3005 88 88 68.3005 88 44C88 19.6995 68.3005 0 44 0C19.6995 0 0 19.6995 0 44C0 68.3005 19.6995 88 44 88Z'
      fill='#D8D8D8'
    />
    <path
      d='M67.9006 37.7148H20.1C16.3762 37.7148 13.3574 41.1882 13.3574 45.4728V80.2426C13.3574 84.5272 16.3762 88.0006 20.1 88.0006H67.9006C71.6244 88.0006 74.6431 84.5272 74.6431 80.2426V45.4728C74.6431 41.1882 71.6244 37.7148 67.9006 37.7148Z'
      fill='white'
    />
    <path
      d='M60.3054 67.0811V66.4918H59.7161H45.5732H44.984V67.0811V69.1015V69.6907H45.5732H59.7161H60.3054V69.1015V67.0811Z'
      fill='black'
      stroke='black'
      strokeWidth='1.17857'
    />
    <path
      d='M41.6124 64.871L42.0291 64.4543L41.6124 64.0376L40.1981 62.6234L39.7814 62.2067L39.3647 62.6234L33.1141 68.874L30.9042 66.6642L30.4875 66.2475L30.0708 66.6642L28.6566 68.0785L28.2399 68.4951L28.6566 68.9118L32.6974 72.9526L33.1141 73.3693L33.5307 72.9526L41.6124 64.871Z'
      fill='black'
      stroke='black'
      strokeWidth='1.17857'
    />
    <path
      d='M60.3054 52.1523V51.5631H59.7161H45.5732H44.984V52.1523V54.1728V54.762H45.5732H59.7161H60.3054V54.1728V52.1523Z'
      fill='black'
      stroke='black'
      strokeWidth='1.17857'
    />
    <path
      d='M41.6124 49.9423L42.0291 49.5256L41.6124 49.1089L40.1981 47.6946L39.7814 47.278L39.3647 47.6946L33.1141 53.9453L30.9042 51.7355L30.4875 51.3188L30.0708 51.7355L28.6566 53.1497L28.2399 53.5664L28.6566 53.9831L32.6974 58.0239L33.1141 58.4406L33.5307 58.0239L41.6124 49.9423Z'
      fill='black'
      stroke='black'
      strokeWidth='1.17857'
    />
    <path
      d='M42.6561 81.8081H21.3623C16.806 81.8081 13.1123 78.1144 13.1123 73.5581V47.4043C13.1123 42.8479 16.806 39.1543 21.3623 39.1543H66.6935C71.2499 39.1543 74.9435 42.8479 74.9435 47.4043V73.5581C74.9435 78.1144 71.2499 81.8081 66.6935 81.8081H54.7266L45.8056 97.6434'
      stroke='black'
      strokeWidth='6.05'
    />
  </svg>
);

export const CloseTaskEmptyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='88'
    height='100'
    viewBox='0 0 88 100'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M44 88C68.3005 88 88 68.3005 88 44C88 19.6995 68.3005 0 44 0C19.6995 0 0 19.6995 0 44C0 68.3005 19.6995 88 44 88Z'
      fill='#D8D8D8'
    />
    <path
      d='M67.9006 37.7148H20.1C16.3762 37.7148 13.3574 41.1882 13.3574 45.4728V80.2426C13.3574 84.5272 16.3762 88.0006 20.1 88.0006H67.9006C71.6244 88.0006 74.6431 84.5272 74.6431 80.2426V45.4728C74.6431 41.1882 71.6244 37.7148 67.9006 37.7148Z'
      fill='white'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M58.9304 51.4371L37.9735 72.9878L29.0732 63.8354L32.4056 60.6132L37.9735 66.3388L55.598 48.2148L58.9304 51.4371Z'
      fill='black'
    />
    <path
      d='M42.6561 81.8071H21.3623C16.806 81.8071 13.1123 78.1134 13.1123 73.5571V47.4033C13.1123 42.847 16.806 39.1533 21.3623 39.1533H66.6935C71.2499 39.1533 74.9435 42.847 74.9435 47.4033V73.5571C74.9435 78.1134 71.2499 81.8071 66.6935 81.8071H54.7266L45.8056 97.6425'
      stroke='black'
      strokeWidth='6.05'
    />
  </svg>
);

export const DraggableIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='12'
    height='40'
    viewBox='0 0 12 40'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M0 0H10C11.1046 0 12 0.895431 12 2V38C12 39.1046 11.1046 40 10 40H0V0Z'
      fill='#D8D8D8'
    />
    <circle cx='4' cy='14' r='1' fill='white' />
    <circle cx='8' cy='14' r='1' fill='white' />
    <circle cx='4' cy='20' r='1' fill='white' />
    <circle cx='8' cy='20' r='1' fill='white' />
    <circle cx='4' cy='26' r='1' fill='white' />
    <circle cx='8' cy='26' r='1' fill='white' />
  </svg>
);

export const MeasureIcon = ({ fill, ...rest }: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='18'
      height='20'
      viewBox='0 0 18 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M15.6947 4.28173L8.31009 0.0817426C8.21597 0.0282086 8.10896 0 8 0C7.89104 0 7.78403 0.0282086 7.68991 0.0817426L0.305292 4.28173C0.212389 4.33457 0.135314 4.41023 0.0817477 4.50117C0.0281815 4.59211 -4.08681e-06 4.69514 4.44461e-10 4.80001V13.2C-4.08681e-06 13.3049 0.0281815 13.4079 0.0817477 13.4988C0.135314 13.5898 0.212389 13.6654 0.305292 13.7183L7.68991 17.9183C7.78403 17.9718 7.89104 18 8 18C8.10896 18 8.21597 17.9718 8.31009 17.9183L15.6947 13.7183C15.7876 13.6654 15.8647 13.5898 15.9183 13.4988C15.9718 13.4079 16 13.3049 16 13.2V4.80001C16 4.69514 15.9718 4.59211 15.9183 4.50117C15.8647 4.41023 15.7876 4.33457 15.6947 4.28173ZM8 1.29464L14.1634 4.80001L8 8.30538L1.83655 4.80001L8 1.29464ZM1.23077 5.84473L7.38462 9.34452V16.3553L1.23077 12.8555V5.84473ZM8.61539 16.3553V9.34452L14.7692 5.84473V12.8555L8.61539 16.3553Z'
        fill={fillColor}
      />
      <line y1='19.5' x2='16' y2='19.5' stroke={fillColor} />
      <line x1='17.5' y1='17' x2='17.5' y2='1' stroke={fillColor} />
    </svg>
  );
};

export const GridIcon = ({ fill, ...rest }: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <g clipPath='url(#clip0_5347_18818)'>
        <path
          d='M12.8884 0.333374H8.79587H5.41087H1.31837C0.774207 0.333374 0.333374 0.774207 0.333374 1.31837V5.41087V8.79587V12.8884C0.333374 13.4325 0.774207 13.8734 1.31837 13.8734H5.41087H8.79587H12.8884C13.4325 13.8734 13.8734 13.4325 13.8734 12.8884V8.79587V5.41087V1.31837C13.8742 0.774207 13.4325 0.333374 12.8884 0.333374ZM13.0275 1.18004V4.56504H9.64254V1.18004H13.0275ZM8.79587 1.18004V4.56504H5.41087V1.18004H8.79587ZM8.79587 5.41087V8.79587H5.41087V5.41087H8.79587ZM1.18004 1.18004H4.56504V4.56504H1.18004V1.18004ZM1.18004 5.41087H4.56504V8.79587H1.18004V5.41087ZM1.18004 13.0275V9.64254H4.56504V13.0275H1.18004ZM5.41087 13.0275V9.64254H8.79587V13.0275H5.41087ZM13.0275 13.0275H9.64254V9.64254H13.0275V13.0275ZM13.0275 8.79587H9.64254V5.41087H13.0275V8.79587Z'
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_5347_18818'>
          <rect
            width='13.5408'
            height='13.5408'
            fill='white'
            transform='translate(0.333374 0.333374)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ExplodeAssemblyIcon = ({
  fill,
  ...rest
}: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='14'
      height='15'
      viewBox='0 0 14 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <g clipPath='url(#clip0_5331_7129)'>
        <path
          d='M12.0276 3.40916C12.0276 3.26075 11.9506 3.12775 11.8217 3.05314L7.20636 0.387445C7.07822 0.314457 6.92008 0.315268 6.79519 0.387445L2.17828 3.05314C2.04933 3.12775 1.97229 3.26075 1.97229 3.40916C1.97229 3.55838 2.04933 3.69138 2.17828 3.76518L6.99956 6.54847L11.8208 3.76518C11.9506 3.69057 12.0276 3.55757 12.0276 3.40916ZM10.6222 3.40916L7.00037 5.49987L3.37853 3.40916L7.00037 1.31764L10.6222 3.40916Z'
          fill={fillColor}
        />
        <path
          d='M0.538491 5.3993C0.410356 5.47391 0.333313 5.60691 0.333313 5.75532V11.1662C0.333313 11.313 0.411978 11.4492 0.539302 11.5214L5.1554 14.1871C5.21947 14.2244 5.29003 14.2422 5.36058 14.2422C5.43195 14.2422 5.5025 14.2236 5.56657 14.1863C5.69552 14.1125 5.77175 13.9795 5.77175 13.8311V8.18421L0.949658 5.40011C0.821523 5.3255 0.666626 5.32469 0.538491 5.3993ZM4.86426 8.7081V12.9706L1.2408 10.8791V6.6174L4.86426 8.7081Z'
          fill={fillColor}
        />
        <path
          d='M13.4615 5.39922C13.3317 5.32461 13.1768 5.32461 13.0503 5.39922L8.229 8.18413V13.831C8.229 13.9802 8.30524 14.1132 8.43418 14.1862C8.49825 14.2235 8.5688 14.2421 8.64017 14.2421C8.71073 14.2421 8.78128 14.2235 8.84535 14.187L13.4606 11.5213C13.588 11.4483 13.6666 11.3121 13.6666 11.1661V5.75524C13.6666 5.60683 13.5904 5.47383 13.4615 5.39922ZM12.7591 6.61731V10.879L9.13649 12.9705V8.70802L12.7591 6.61731Z'
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_5331_7129'>
          <rect
            width='13.3333'
            height='13.9099'
            fill='white'
            transform='translate(0.333313 0.333252)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ClipSectionIcon = ({ fill, ...rest }: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='11'
      height='18'
      viewBox='0 0 11 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <g clipPath='url(#clip0_5347_21098)'>
        <path
          d='M8.52334 3.69922H7.40167V4.32422H8.52334V3.69922Z'
          stroke={fill || '#646464'}
        />
        <path
          d='M10.79 4.84505H10.165V4.32422H9.64417V3.69922H10.79V4.84505Z'
          stroke={fill || '#646464'}
        />
        <path
          d='M10.79 11.5596H10.165V9.88045H10.79V11.5596ZM10.79 8.20212H10.165V6.52295H10.79V8.20212Z'
          stroke={fill || '#646464'}
        />
        <path
          d='M10.79 14.3841H9.64417V13.7591H10.165V13.2383H10.79V14.3841Z'
          stroke={fill || '#646464'}
        />
        <path
          d='M8.52334 13.7588H7.40167V14.3838H8.52334V13.7588Z'
          stroke={fill || '#646464'}
        />
        <path
          d='M6.28086 3.69922H5.8642V4.32422H6.28086V3.69922Z'
          stroke={fill || '#646464'}
        />
        <path
          d='M6.28086 13.7588H5.8642V14.3838H6.28086V13.7588Z'
          stroke={fill || '#646464'}
        />
        <path
          d='M5.03083 0.666504V3.59484H0.8825C0.395 3.59484 0 3.98984 0 4.4765V13.6057C0 14.0923 0.395 14.4882 0.8825 14.4882H5.03083V17.4165H5.86417V14.4882V3.59484V0.666504H5.03083ZM0.833333 13.6548V4.42817H5.03083V13.6548H0.833333Z'
          stroke={fillColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_5347_21098'>
          <rect
            width='10.79'
            height='16.75'
            fill='white'
            transform='translate(0 0.666504)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const RulerIcon = ({ fill, ...rest }: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <g clipPath='url(#clip0_5586_22802)'>
        <path
          d='M7 2L22.5563 17.5563L18.7851 21.3276C18.0041 22.1086 16.7377 22.1086 15.9567 21.3276L3.22876 8.59966C2.44771 7.81861 2.44772 6.55228 3.22876 5.77124L7 2Z'
          fill='white'
          stroke={fillColor}
          strokeWidth='1.5'
        />
        <line
          x1='10.1509'
          y1='6.15094'
          x2='7.32251'
          y2='8.97936'
          stroke={fillColor}
          strokeWidth='1.5'
        />
        <line
          x1='14.3936'
          y1='10.3936'
          x2='11.5652'
          y2='13.222'
          stroke={fillColor}
          strokeWidth='1.5'
        />
        <line
          x1='18.6362'
          y1='14.6363'
          x2='15.8078'
          y2='17.4647'
          stroke={fillColor}
          strokeWidth='1.5'
        />
        <line
          x1='13.1509'
          y1='7.15094'
          x2='11.0296'
          y2='9.27226'
          stroke={fillColor}
          strokeWidth='1.5'
        />
        <line
          x1='17.3936'
          y1='11.3936'
          x2='15.2723'
          y2='13.5149'
          stroke={fillColor}
          strokeWidth='1.5'
        />
      </g>
      <defs>
        <clipPath id='clip0_5586_22802'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const Text3DIcon = ({ fill, ...rest }: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='20'
      height='17'
      viewBox='0 0 20 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M19.1667 4.4732L16.2764 6.18206L13.0063 5.54915L9.18776 7.84873L10.4114 9.72636L7.5 11.5196L0.854431 2.57447L3.38608 0.992188L19.1667 4.4732ZM19.1667 4.4732V8.71371L16.2764 10.4226L13.0063 9.72636L10.6435 11.2454'
        stroke={fillColor}
        strokeLinejoin='round'
      />
      <path
        d='M16.2764 6.20312V10.5069M12.9219 5.59131V9.81072'
        stroke={fillColor}
        strokeLinejoin='round'
      />
      <path
        d='M7.47888 11.5194V15.7177M7.47888 15.7177L10.4325 13.9666V9.70502M7.47888 15.7177L0.833313 6.85692V2.57422'
        stroke={fillColor}
        strokeLinejoin='round'
      />
      <path
        d='M7.52108 5.69662L6.44513 4.19873L9.08226 4.68396L7.52108 5.69662Z'
        stroke={fillColor}
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const ResetCameraIcon = ({ fill, ...rest }: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='23'
      height='22'
      viewBox='0 0 23 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <g clipPath='url(#clip0_5347_21046)'>
        <path
          stroke={fillColor}
          d='M15.4666 13.8282V12.2015L17.64 13.7532C17.7083 13.8015 17.79 13.8282 17.8733 13.8282C18.095 13.8282 18.2741 13.6482 18.2741 13.4274V7.8132C18.2741 7.72986 18.2483 7.6482 18.1991 7.57986C18.07 7.39986 17.82 7.3582 17.64 7.48736L15.4666 9.03903V7.41153C15.4658 6.96903 15.1075 6.60986 14.6641 6.60986H7.84665C7.40415 6.6107 7.04582 6.96903 7.04498 7.41153V13.8282C7.04582 14.2707 7.40415 14.6299 7.84665 14.6307H14.6641C15.1075 14.6299 15.4658 14.2715 15.4666 13.8282ZM7.84665 7.41153H14.6641V9.81736C14.6641 9.9007 14.69 9.98236 14.7391 10.0507C14.8683 10.2307 15.1183 10.2724 15.2983 10.1432L17.4716 8.59153V12.6474L15.2983 11.0957C15.23 11.0474 15.1483 11.0207 15.065 11.0207C14.8433 11.0207 14.6641 11.2007 14.6641 11.4215V13.8274H7.84665V7.41153Z'
        />
        <path
          stroke={fillColor}
          d='M12.2058 0.166504C6.71999 0.166504 2.21666 4.4165 1.79332 9.79567L0.64749 8.64984L0.166656 9.13067L2.20582 11.1698L4.24499 9.13067L3.76332 8.64984L2.70499 9.70734C3.16666 4.87067 7.24999 1.074 12.2058 1.074C17.4692 1.074 21.7517 5.3565 21.7517 10.6207C21.7517 15.8848 17.4692 20.1665 12.2058 20.1665V21.0748C17.97 21.0748 22.66 16.3848 22.66 10.6207C22.66 4.8565 17.97 0.166504 12.2058 0.166504Z'
        />
      </g>
      <defs>
        <clipPath id='clip0_5347_21046'>
          <rect
            width='22.4933'
            height='20.9075'
            fill={fillColor}
            transform='translate(0.166656 0.166504)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PanModeIcon = ({ fill, ...rest }: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <rect x='0.5' y='0.5' width='39' height='39' stroke='black' />
      <rect width='40' height='40' fill='white' />
      <g clipPath='url(#clip0_5347_5758)'>
        <path
          d='M32.1533 18.3917L31.7125 18.8333L32.7266 19.8475H26.0641L26.0575 17.4425C26.0558 16.975 25.8033 16.54 25.3991 16.3067L20.5541 13.5092C20.1483 13.275 19.6408 13.2742 19.235 13.5108L14.4608 16.2858C14.0575 16.5192 13.8066 16.9542 13.8058 17.4192L13.7975 19.8475H7.13415L8.14831 18.8333L7.70665 18.3917L5.83331 20.2642L7.70665 22.1367L8.14748 21.6942L7.13415 20.6808H13.795L13.7883 23.09C13.7875 23.5592 14.04 23.9983 14.4466 24.2333L19.2725 27.02C19.4758 27.1375 19.7033 27.1958 19.9308 27.1958C20.1575 27.1958 20.3858 27.1375 20.5883 27.02L25.415 24.2333C25.8225 23.9983 26.0741 23.5592 26.0725 23.09L26.0658 20.6808H32.7258L31.7125 21.6942L32.1533 22.1367L34.0266 20.2642L32.1533 18.3917ZM24.5883 16.9425L19.93 19.6492L15.2433 16.9433L19.9016 14.2367L24.5883 16.9425ZM19.4508 21.1458L19.4375 26.0108L14.7508 23.305L14.7658 17.9183L19.4491 20.6217L19.4508 21.1458ZM25.1141 23.3033L20.4275 26.0092L20.4125 20.6217L25.0983 17.9158L25.1141 23.3033Z'
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_5347_5758'>
          <rect
            width='28.1933'
            height='13.8625'
            fill='white'
            transform='translate(5.83331 13.3333)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OrbitModeIcon = ({ fill, ...rest }: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='25'
      height='22'
      viewBox='0 0 25 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <g clipPath='url(#clip0_5347_5767)'>
        <path
          d='M17.1725 7.56837L12.9292 5.11921C12.5658 4.90921 12.115 4.90921 11.7525 5.12087L7.57167 7.55087C7.2125 7.75921 6.98917 8.14671 6.9875 8.56254L6.97334 13.5275C6.97167 13.9475 7.1975 14.3384 7.56 14.5475L11.7858 16.9875C11.9675 17.0917 12.17 17.1442 12.3733 17.1442C12.5758 17.1442 12.7783 17.0917 12.96 16.9875L17.1867 14.5475C17.55 14.3375 17.775 13.9467 17.7725 13.5275L17.7583 8.58171C17.7583 8.16587 17.5342 7.77754 17.1725 7.56837ZM11.9308 11.8259L11.9183 16.0459L7.86 13.7025L7.87417 9.03671L11.93 11.3784L11.9308 11.8259ZM16.4067 8.14504L12.3725 10.4892L8.31334 8.14587L12.3475 5.80171L16.4067 8.14504ZM16.8892 13.7017L12.8308 16.045L12.8175 11.3792L16.875 9.03587L16.8892 13.7017Z'
          fill={fillColor}
        />
        <path
          d='M3.92998 8.65002L2.87248 9.70752C3.33415 4.87085 7.41665 1.07419 12.3725 1.07419C15.72 1.07419 18.865 2.86252 20.58 5.74252L21.36 5.27752C19.4825 2.12502 16.0383 0.166687 12.3725 0.166687C6.88665 0.166687 2.38331 4.41669 1.96081 9.79585L0.81498 8.65002L0.333313 9.13085L2.37248 11.17L4.41165 9.13085L3.92998 8.65002Z'
          fill={fillColor}
        />
        <path
          d='M24.4125 12.1783L22.3733 10.1392L20.3333 12.1783L20.815 12.66L21.8675 11.6075C21.3717 16.4092 17.3033 20.1667 12.3725 20.1667C9.00332 20.1667 5.94832 18.445 4.20082 15.5592L3.42499 16.0292C5.33832 19.1883 8.68332 21.075 12.3725 21.075C17.8358 21.075 22.3275 16.8592 22.7817 11.5117L23.93 12.6608L24.4125 12.1783Z'
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_5347_5767'>
          <rect
            width='24.0792'
            height='20.9075'
            fill='white'
            transform='translate(0.333313 0.166687)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const HideUnChangeIcon = ({
  fill,
  ...rest
}: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <g clipPath='url(#clip0_5886_22509)'>
        <path
          d='M11 4.22727V3.5C11 2.39543 11.8954 1.5 13 1.5H21C22.1046 1.5 23 2.39543 23 3.5V11.8636C23 12.7674 22.2674 13.5 21.3636 13.5V13.5'
          stroke={fillColor}
        />
        <path
          d='M14 19.5V20.5C14 21.6046 13.1046 22.5 12 22.5H4C2.89543 22.5 2 21.6046 2 20.5V12.5C2 11.3954 2.89543 10.5 4 10.5H4.5'
          stroke={fillColor}
        />
        <path
          d='M6.76118 15.8056L7.52387 15.0483C6.68876 14.2984 6.03261 13.3707 5.60381 12.3335C6.68651 9.62944 9.67326 7.53337 12.5 7.53337C13.2274 7.54298 13.9483 7.67273 14.6334 7.91739L15.4601 7.08536C14.5228 6.68925 13.5175 6.47913 12.5 6.46667C10.7616 6.53205 9.08039 7.10539 7.66424 8.11584C6.2481 9.12628 5.15908 10.5295 4.53177 12.1522C4.48941 12.2694 4.48941 12.3977 4.53177 12.5149C5.00552 13.772 5.76937 14.8995 6.76118 15.8056Z'
          fill={fillColor}
        />
        <path
          d='M10.3666 12.1895C10.4037 11.6784 10.6235 11.1977 10.9858 10.8353C11.3482 10.473 11.8289 10.2532 12.34 10.2161L13.3053 9.24537C12.7644 9.10294 12.1956 9.10479 11.6556 9.25074C11.1156 9.39669 10.6232 9.68164 10.2277 10.0772C9.83215 10.4727 9.5472 10.965 9.40125 11.505C9.2553 12.045 9.25345 12.6139 9.39588 13.1548L10.3666 12.1895Z'
          fill={fillColor}
        />
        <path
          d='M20.4681 12.1523C19.8565 10.5592 18.7924 9.17991 17.4067 8.18413L19.9667 5.61872L19.2147 4.8667L5.03296 19.0485L5.78498 19.8005L8.50506 17.0804C9.71784 17.7919 11.094 18.1777 12.4999 18.2004C14.2383 18.1351 15.9195 17.5617 17.3356 16.5513C18.7518 15.5408 19.8408 14.1376 20.4681 12.5149C20.5105 12.3978 20.5105 12.2694 20.4681 12.1523ZM14.6333 12.3336C14.631 12.707 14.5308 13.0733 14.3426 13.3958C14.1545 13.7183 13.885 13.9858 13.561 14.1715C13.2371 14.3573 12.8701 14.4547 12.4967 14.4542C12.1232 14.4536 11.7565 14.355 11.4332 14.1683L14.3346 11.2669C14.5263 11.59 14.6293 11.9579 14.6333 12.3336ZM12.4999 17.1337C11.3809 17.1142 10.2832 16.8251 9.29976 16.291L10.6545 14.9363C11.2707 15.3639 12.0175 15.5614 12.7645 15.4945C13.5115 15.4275 14.2112 15.1003 14.7416 14.57C15.2719 14.0396 15.5991 13.3399 15.6661 12.5929C15.733 11.8459 15.5355 11.0991 15.1079 10.4829L16.6386 8.95216C17.8625 9.79217 18.8195 10.9658 19.3961 12.3336C18.3134 15.0377 15.3266 17.1337 12.4999 17.1337Z'
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_5886_22509'>
          <rect width='24' height='24' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const AnnotationIcon = ({ fill, ...rest }: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M21.249 12.0067V12.0068C21.249 17.1146 17.1082 21.2563 11.9995 21.2563H2.75L2.75 12.0059C2.75 6.89814 6.8918 2.75635 11.9995 2.75635C17.1082 2.75635 21.2499 6.89814 21.249 12.0067Z'
        fill='transparent'
        stroke={fillColor}
        strokeWidth='1.5'
      />
    </svg>
  );
};

export const SendIcon = ({ fill, ...rest }: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <g clipPath='url(#clip0_5548_18599)'>
        <path
          d='M13.5628 2.29001L1.89558 6.1791C1.80413 6.20957 1.72344 6.26583 1.66322 6.3411C1.603 6.41638 1.56583 6.50745 1.55617 6.60336C1.54801 6.69602 1.56586 6.78911 1.6077 6.87218C1.64955 6.95525 1.71374 7.025 1.79305 7.07359L6.64734 9.83484L9.38384 14.6927C9.42283 14.7605 9.47719 14.8182 9.54255 14.8612C9.60791 14.9042 9.68245 14.9312 9.76017 14.9402C9.83789 14.9491 9.91662 14.9397 9.99003 14.9127C10.0635 14.8857 10.1295 14.8418 10.1829 14.7846C10.2379 14.7289 10.2791 14.6611 10.3031 14.5866L14.1922 2.91934C14.2204 2.83175 14.2239 2.73808 14.2024 2.64862C14.1808 2.55916 14.1349 2.4774 14.0699 2.41233C14.0048 2.34726 13.923 2.30141 13.8336 2.27982C13.7441 2.25824 13.6504 2.26177 13.5628 2.29001ZM9.70911 13.2148L7.62315 9.56614L10.89 6.29931L10.1829 5.5922L6.91604 8.85903L3.26737 6.77307L12.9264 3.55573L9.70911 13.2148Z'
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_5548_18599'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ExpandIcon = ({ fill, ...rest }: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='6'
      height='10'
      viewBox='0 0 6 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0.135327 5L5.16113 0L5.86475 0.7L1.54255 5L5.86475 9.3L5.16113 10L0.135327 5Z'
        fill={fillColor}
      />
    </svg>
  );
};

export const DfMIcon = ({ fill, ...rest }: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <g clipPath='url(#clip0_4057_14272)'>
        <path d='M19.0588 2H22V4.94118' stroke={fillColor} strokeWidth='1.5' />
        <path
          d='M2 4.94141V2.00023H4.94118'
          stroke={fillColor}
          strokeWidth='1.5'
        />
        <path
          d='M4.94116 22H1.99999L1.99999 19.0588'
          stroke={fillColor}
          strokeWidth='1.5'
        />
        <path
          d='M22 19.0591V22.0003H19.0588'
          stroke={fillColor}
          strokeWidth='1.5'
        />
        <path
          d='M12 2.58838L20.1508 7.29426V16.706L12 21.4119L3.84919 16.706V7.29426L12 2.58838Z'
          stroke={fillColor}
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
        <path
          d='M15.9665 16.2534L20.1221 7.30811H3.87787L8.06086 16.2534L12 21.3572L15.9665 16.2534Z'
          stroke={fillColor}
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
        <path
          d='M12 2.61572V7.30789M12 7.30789L8.06086 16.2532L3.87787 16.6922M12 7.30789L15.994 16.2532L20.1221 16.6922'
          stroke={fillColor}
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
        <path
          d='M16.9661 16.2534H7.08789'
          stroke={fillColor}
          strokeWidth='1.5'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_4057_14272'>
          <rect width='24' height='24' fill='transparent' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PointOnSurfaceIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle
        cx='12.6025'
        cy='12.5'
        r='9.25'
        stroke='black'
        strokeWidth='1.5'
      />
      <mask id='path-2-inside-1_3982_32928' fill='white'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M13.6025 8.5H11.6025V11.5H8.60254V13.5H11.6025V16.5H13.6025V13.5H16.6025V11.5H13.6025V8.5Z'
        />
      </mask>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.6025 8.5H11.6025V11.5H8.60254V13.5H11.6025V16.5H13.6025V13.5H16.6025V11.5H13.6025V8.5Z'
        fill='#D8D8D8'
      />
      <path
        d='M13.6025 8.5H15.6025V6.5H13.6025V8.5ZM11.6025 8.5V6.5H9.60254V8.5H11.6025ZM11.6025 11.5V13.5H13.6025V11.5H11.6025ZM8.60254 11.5V9.5H6.60254V11.5H8.60254ZM8.60254 13.5H6.60254V15.5H8.60254V13.5ZM11.6025 13.5H13.6025V11.5H11.6025V13.5ZM11.6025 16.5H9.60254V18.5H11.6025V16.5ZM13.6025 16.5V18.5H15.6025V16.5H13.6025ZM13.6025 13.5V11.5H11.6025V13.5H13.6025ZM16.6025 13.5V15.5H18.6025V13.5H16.6025ZM16.6025 11.5H18.6025V9.5H16.6025V11.5ZM13.6025 11.5H11.6025V13.5H13.6025V11.5ZM13.6025 6.5H11.6025V10.5H13.6025V6.5ZM9.60254 8.5V11.5H13.6025V8.5H9.60254ZM11.6025 9.5H8.60254V13.5H11.6025V9.5ZM6.60254 11.5V13.5H10.6025V11.5H6.60254ZM8.60254 15.5H11.6025V11.5H8.60254V15.5ZM9.60254 13.5V16.5H13.6025V13.5H9.60254ZM11.6025 18.5H13.6025V14.5H11.6025V18.5ZM15.6025 16.5V13.5H11.6025V16.5H15.6025ZM13.6025 15.5H16.6025V11.5H13.6025V15.5ZM18.6025 13.5V11.5H14.6025V13.5H18.6025ZM16.6025 9.5H13.6025V13.5H16.6025V9.5ZM15.6025 11.5V8.5H11.6025V11.5H15.6025Z'
        fill='#0F2EFF'
        mask='url(#path-2-inside-1_3982_32928)'
      />
    </svg>
  );
};

export const TargetVertexIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M21.6184 6.23323L12.3876 1.09991C12.27 1.03448 12.1362 1 12 1C11.8638 1 11.73 1.03448 11.6124 1.09991L2.38162 6.23323C2.26549 6.29781 2.16914 6.39029 2.10218 6.50143C2.03523 6.61258 1.99999 6.73851 2 6.86668V17.1333C1.99999 17.2615 2.03523 17.3874 2.10218 17.4986C2.16914 17.6097 2.26549 17.7022 2.38162 17.7668L11.6124 22.9001C11.73 22.9655 11.8638 23 12 23C12.1362 23 12.27 22.9655 12.3876 22.9001L21.6184 17.7668C21.7345 17.7022 21.8309 17.6097 21.8978 17.4986C21.9648 17.3874 22 17.2615 22 17.1333V6.86668C22 6.73851 21.9648 6.61258 21.8978 6.50143C21.8309 6.39029 21.7345 6.29781 21.6184 6.23323ZM12 2.58234L19.7043 6.86668L12 11.151L4.29569 6.86668L12 2.58234ZM3.53846 8.14356L11.2308 12.4211V20.9898L3.53846 16.7122V8.14356ZM12.7692 20.9898V12.4211L20.4615 8.14356V16.7122L12.7692 20.9898Z'
        fill='black'
      />
      <rect
        x='9.25'
        y='14.75'
        width='5.5'
        height='5.5'
        transform='rotate(-90 9.25 14.75)'
        fill='#0F2EFF'
        stroke='white'
        strokeWidth='1.5'
      />
    </svg>
  );
};

export const MeasureRadiusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='22'
      height='21'
      viewBox='0 0 22 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect x='9.10254' y='9' width='3' height='3' fill='#0F2EFF' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M18.6104 13.3571C17.4369 16.6461 14.2946 19 10.6025 19C5.90812 19 2.10254 15.1944 2.10254 10.5C2.10254 5.80558 5.90812 2 10.6025 2C14.2946 2 17.4369 4.35392 18.6104 7.64286H20.1884C18.9591 3.51216 15.1326 0.5 10.6025 0.5C5.07969 0.5 0.602539 4.97715 0.602539 10.5C0.602539 16.0228 5.07969 20.5 10.6025 20.5C15.1326 20.5 18.9591 17.4878 20.1884 13.3571H18.6104Z'
        fill='black'
      />
      <rect x='18.1025' y='9' width='3' height='3' fill='#0F2EFF' />
      <path d='M10.6025 10.5H19.174' stroke='#0F2EFF' strokeWidth='1.5' />
    </svg>
  );
};

export const RotateIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_6118_59561)'>
        <path
          d='M10.041 12.2921L9.5814 10.935H6.342L5.8933 12.2921H4L6.86731 4.5H9.06703L12 12.2921H10.041ZM6.85636 9.39193H9.05609L8.60739 8.05677C8.39945 7.47674 8.16963 6.76539 7.95075 6.08687C7.73187 6.76539 7.50205 7.47674 7.30506 8.05677L6.85636 9.39193Z'
          fill='black'
        />
        <path
          d='M14.3334 12.3567C14.3334 14.1976 11.4979 15.69 8.00008 15.69C4.50228 15.69 1.66675 14.1976 1.66675 12.3567'
          stroke='black'
          strokeWidth='0.666667'
        />
        <path
          d='M15.1021 13.457L14.5044 12.1753L13.2227 12.7729'
          stroke='black'
          strokeWidth='0.666667'
        />
        <path
          d='M1.66658 5.16821C1.66658 3.32726 4.50211 1.83488 7.99992 1.83488C11.4977 1.83488 14.3333 3.32726 14.3333 5.16821'
          stroke='black'
          strokeWidth='0.666667'
        />
        <path
          d='M0.897938 4.06792L1.49561 5.34963L2.77732 4.75196'
          stroke='black'
          strokeWidth='0.666667'
        />
      </g>
      <defs>
        <clipPath id='clip0_6118_59561'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(0 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const OffsetIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <line
        x1='13.6666'
        y1='7.83325'
        x2='13.6666'
        y2='15.1666'
        stroke='black'
        strokeWidth='0.666667'
      />
      <line
        x1='2.33333'
        y1='7.83325'
        x2='2.33333'
        y2='15.1666'
        stroke='black'
        strokeWidth='0.666667'
      />
      <line
        x1='13'
        y1='13.5001'
        x2='3'
        y2='13.5001'
        stroke='black'
        strokeWidth='0.666667'
      />
      <path
        d='M10.041 9.95881L9.5814 8.60177H6.342L5.8933 9.95881H4L6.86731 2.16675H9.06703L12 9.95881H10.041ZM6.85636 7.05868H9.05609L8.60739 5.72352C8.39945 5.14349 8.16963 4.43214 7.95075 3.75362C7.73187 4.43214 7.50205 5.14349 7.30506 5.72352L6.85636 7.05868Z'
        fill='black'
      />
      <path
        d='M3.83325 12.5L2.83325 13.5L3.83325 14.5'
        stroke='black'
        strokeWidth='0.666667'
      />
      <path
        d='M12.1667 14.5L13.1667 13.5L12.1667 12.5'
        stroke='black'
        strokeWidth='0.666667'
      />
    </svg>
  );
};

export const PlaneIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M1.5 3.25785C1.5 2.93797 1.79621 2.70036 2.10847 2.76975L11.3415 4.82154C11.5003 4.85683 11.632 4.96716 11.6946 5.11732L14.0571 10.7873C14.1804 11.0833 13.9971 11.4173 13.6812 11.4722L2.08567 13.4888C1.77986 13.542 1.5 13.3066 1.5 12.9962V3.25785Z'
        stroke='#777777'
      />
    </svg>
  );
};

export const MeasureCenterIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='20'
      height='21'
      viewBox='0 0 20 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect x='2' y='3' width='16' height='16' rx='8' stroke='black' />
      <rect x='9' y='10' width='2' height='2' rx='1' stroke='black' />
      <path d='M12.9644 13.9644L18.9644 19.9644' stroke='black' />
      <path d='M12.5 16.5V13.5H15.5' stroke='black' />
      <path d='M7.03558 13.9644L1.03558 19.9644' stroke='black' />
      <path d='M7.5 16.5V13.5H4.5' stroke='black' />
      <path d='M10 8L10 5.33268e-08' stroke='black' />
      <path d='M12.1213 6.12132L10 8.24264L7.87868 6.12132' stroke='black' />
    </svg>
  );
};

export const EllipseIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_6109_45281)'>
        <ellipse
          cx='7.79583'
          cy='8.01987'
          rx='6.5'
          ry='4.33333'
          transform='rotate(-30 7.79583 8.01987)'
          stroke='#777777'
        />
      </g>
      <defs>
        <clipPath id='clip0_6109_45281'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(0 0.0170898)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SingleLineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect
        x='10.4853'
        y='3.51465'
        width='2'
        height='2'
        transform='rotate(-45 10.4853 3.51465)'
        fill='#777777'
      />
      <line x1='11.8995' y1='3.51469' x2='3.41423' y2='12' stroke='#777777' />
      <rect
        x='2'
        y='12'
        width='2'
        height='2'
        transform='rotate(-45 2 12)'
        fill='#777777'
      />
    </svg>
  );
};

export const EdgeMidPointIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <line
        x1='22.5205'
        y1='12'
        x2='2.52051'
        y2='12'
        stroke='black'
        strokeWidth='1.5'
      />
      <line
        x1='22.7705'
        y1='14'
        x2='22.7705'
        y2='10'
        stroke='black'
        strokeWidth='1.5'
      />
      <line
        x1='2.27051'
        y1='14'
        x2='2.27051'
        y2='10'
        stroke='black'
        strokeWidth='1.5'
      />
      <rect
        x='9.77051'
        y='14.75'
        width='5.5'
        height='5.5'
        transform='rotate(-90 9.77051 14.75)'
        fill='#0F2EFF'
        stroke='white'
        strokeWidth='1.5'
      />
    </svg>
  );
};

export const FaceMidPoint = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M21.4812 6.73323L12.2504 1.59991C12.1328 1.53448 11.999 1.5 11.8628 1.5C11.7266 1.5 11.5928 1.53448 11.4752 1.59991L2.24441 6.73323C2.12828 6.79781 2.03194 6.89029 1.96498 7.00143C1.89802 7.11258 1.86279 7.23851 1.86279 7.36668V17.6333C1.86279 17.7615 1.89802 17.8874 1.96498 17.9986C2.03194 18.1097 2.12828 18.2022 2.24441 18.2668L11.4752 23.4001C11.5928 23.4655 11.7266 23.5 11.8628 23.5C11.999 23.5 12.1328 23.4655 12.2504 23.4001L21.4812 18.2668C21.5973 18.2022 21.6937 18.1097 21.7606 17.9986C21.8276 17.8874 21.8628 17.7615 21.8628 17.6333V7.36668C21.8628 7.23851 21.8276 7.11258 21.7606 7.00143C21.6937 6.89029 21.5973 6.79781 21.4812 6.73323ZM11.8628 3.08234L19.5671 7.36668L11.8628 11.651L4.15849 7.36668L11.8628 3.08234ZM3.40125 8.64356L11.0936 12.9211V21.4898L3.40125 17.2122V8.64356ZM12.632 21.4898V12.9211L20.3243 8.64356V17.2122L12.632 21.4898Z'
        fill='black'
      />
      <path
        d='M5.6994 15.9869L5.6994 12.6606L8.68581 14.3221L8.68581 17.6606L5.6994 15.9869Z'
        fill='#0F2EFF'
      />
    </svg>
  );
};

export const Select3DIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_4019_10742)'>
        <path d='M6.5 2.5H2V7.005H3V3.5H6.5V2.5Z' fill='#0F2EFF' />
        <path
          d='M14.7451 7.05991L10.2451 4.55991C10.1691 4.51602 10.0829 4.49292 9.9951 4.49292C9.90733 4.49292 9.82111 4.51602 9.7451 4.55991L5.2451 7.05991C5.16898 7.10501 5.1062 7.16951 5.06316 7.24681C5.02011 7.32411 4.99835 7.41145 5.0001 7.49991V12.4999C5.00075 12.589 5.02519 12.6763 5.0709 12.7528C5.11661 12.8293 5.18193 12.8921 5.2601 12.9349L9.7601 15.4349C9.83335 15.4764 9.9159 15.4988 10.0001 15.4999C10.0858 15.4986 10.17 15.4763 10.2451 15.4349L14.7451 12.9349C14.8223 12.8915 14.8866 12.8283 14.9314 12.7519C14.9763 12.6755 14.9999 12.5885 15.0001 12.4999V7.49991C15.0008 7.41046 14.9776 7.32246 14.9327 7.24507C14.8879 7.16768 14.8231 7.10373 14.7451 7.05991ZM9.5001 14.1499L6.0001 12.2049V8.34491L9.5001 10.2899V14.1499ZM10.0001 9.42491L6.5301 7.49991L10.0001 5.56991L13.4701 7.49991L10.0001 9.42491ZM14.0001 12.2049L10.5001 14.1499V10.2899L14.0001 8.34491V12.2049Z'
          fill='#0F2EFF'
        />
      </g>
      <defs>
        <clipPath id='clip0_4019_10742'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(0 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const TriangleVertex = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_6150_28530)'>
        <path
          d='M12 5.25342L20.6521 20.2392H3.34794L12 5.25342Z'
          stroke='black'
          strokeWidth='1.5'
        />
        <rect
          x='9.25'
          y='8.00342'
          width='5.5'
          height='5.5'
          transform='rotate(-90 9.25 8.00342)'
          fill='#0F2EFF'
          stroke='white'
          strokeWidth='1.5'
        />
      </g>
      <defs>
        <clipPath id='clip0_6150_28530'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(0 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EyeIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_3947_15071)'>
        <path
          d='M15.4698 8.36711C14.8817 6.84593 13.8608 5.53042 12.5332 4.58315C11.2056 3.63589 9.62953 3.0984 7.99979 3.03711C6.37005 3.0984 4.79398 3.63589 3.46639 4.58315C2.1388 5.53042 1.11787 6.84593 0.529787 8.36711C0.490071 8.47696 0.490071 8.59726 0.529787 8.70711C1.11787 10.2283 2.1388 11.5438 3.46639 12.4911C4.79398 13.4383 6.37005 13.9758 7.99979 14.0371C9.62953 13.9758 11.2056 13.4383 12.5332 12.4911C13.8608 11.5438 14.8817 10.2283 15.4698 8.70711C15.5095 8.59726 15.5095 8.47696 15.4698 8.36711ZM7.99979 13.0371C5.34979 13.0371 2.54979 11.0721 1.53479 8.53711C2.54979 6.00211 5.34979 4.03711 7.99979 4.03711C10.6498 4.03711 13.4498 6.00211 14.4648 8.53711C13.4498 11.0721 10.6498 13.0371 7.99979 13.0371Z'
          fill='black'
        />
        <path
          d='M8 5.53711C7.40666 5.53711 6.82664 5.71306 6.33329 6.0427C5.83994 6.37234 5.45543 6.84088 5.22836 7.38906C5.0013 7.93724 4.94189 8.54044 5.05765 9.12238C5.1734 9.70432 5.45912 10.2389 5.87868 10.6584C6.29824 11.078 6.83279 11.3637 7.41473 11.4795C7.99667 11.5952 8.59987 11.5358 9.14805 11.3087C9.69623 11.0817 10.1648 10.6972 10.4944 10.2038C10.8241 9.71047 11 9.13045 11 8.53711C11 7.74146 10.6839 6.9784 10.1213 6.41579C9.55871 5.85318 8.79565 5.53711 8 5.53711ZM8 10.5371C7.60444 10.5371 7.21776 10.4198 6.88886 10.2C6.55996 9.98029 6.30362 9.66793 6.15224 9.30248C6.00087 8.93702 5.96126 8.53489 6.03843 8.14693C6.1156 7.75897 6.30608 7.4026 6.58579 7.1229C6.86549 6.84319 7.22186 6.65271 7.60982 6.57554C7.99778 6.49837 8.39992 6.53797 8.76537 6.68935C9.13082 6.84073 9.44318 7.09707 9.66294 7.42597C9.8827 7.75487 10 8.14155 10 8.53711C10 9.06754 9.78929 9.57625 9.41421 9.95132C9.03914 10.3264 8.53043 10.5371 8 10.5371Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_3947_15071'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(0 0.537109)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EnlargeIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M9.90474 2.00513V2.95751H13.0476L8.47617 7.52894L9.14284 8.1956L13.7143 3.62417V6.76703H14.6666V2.00513H9.90474ZM7.52379 9.81465L6.85712 9.14798L2.28569 13.7194V10.5766H1.33331V15.3385H6.09522V14.3861H2.95236L7.52379 9.81465Z'
        fill='black'
      />
    </svg>
  );
};

export const MeasureAngleIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='20'
      height='19'
      viewBox='0 0 20 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M6.60254 9.5C9.19101 12.642 10.043 14.393 10.6025 17.5'
        stroke='#0F2EFF'
        strokeWidth='1.5'
        strokeLinecap='square'
        strokeLinejoin='bevel'
      />
      <path
        d='M19.1025 17.5H0.602539L12.1025 1.5'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='square'
        strokeLinejoin='bevel'
      />
    </svg>
  );
};

export const LineIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M7.20258 20.0984L20.4026 7.60913'
        stroke='black'
        strokeWidth='1.5'
      />
      <rect
        x='5.75256'
        y='18.7668'
        width='2.9'
        height='2.66308'
        rx='1.33154'
        fill='white'
        stroke='black'
        strokeWidth='1.5'
      />
      <rect
        x='18.9526'
        y='6.27759'
        width='2.9'
        height='2.66308'
        rx='1.33154'
        fill='white'
        stroke='black'
        strokeWidth='1.5'
      />
      <path
        d='M17.6025 3.83333L16.2072 2.5L2.60254 15.1667L3.99789 16.5'
        stroke='#0F2EFF'
        strokeWidth='1.5'
      />
    </svg>
  );
};

export const MeasurePlaneOffsetIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_3982_32955)'>
        <path
          d='M3.60254 18.0368V6.17368L14.4341 1.5V13.3631L3.60254 18.0368Z'
          stroke='black'
          strokeWidth='1.5'
        />
        <path
          d='M16.1025 14.5L9.10234 9.49978'
          stroke='#0F2EFF'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
        <path
          d='M10.6129 22.5002V10.6371L21.4445 5.96338V17.8265L10.6129 22.5002Z'
          fill='white'
          fillOpacity='0.5'
          stroke='black'
          strokeWidth='1.5'
        />
      </g>
      <defs>
        <clipPath id='clip0_3982_32955'>
          <rect
            width='24'
            height='24'
            fill='white'
            transform='translate(0.602539 0.5)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DimensionIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M21.6184 6.23323L12.3876 1.09991C12.27 1.03448 12.1362 1 12 1C11.8638 1 11.73 1.03448 11.6124 1.09991L2.38162 6.23323C2.26549 6.29781 2.16914 6.39029 2.10218 6.50143C2.03523 6.61258 1.99999 6.73851 2 6.86668V17.1333C1.99999 17.2615 2.03523 17.3874 2.10218 17.4986C2.16914 17.6097 2.26549 17.7022 2.38162 17.7668L11.6124 22.9001C11.73 22.9655 11.8638 23 12 23C12.1362 23 12.27 22.9655 12.3876 22.9001L21.6184 17.7668C21.7345 17.7022 21.8309 17.6097 21.8978 17.4986C21.9648 17.3874 22 17.2615 22 17.1333V6.86668C22 6.73851 21.9648 6.61258 21.8978 6.50143C21.8309 6.39029 21.7345 6.29781 21.6184 6.23323ZM12 2.58234L19.7043 6.86668L12 11.151L4.29569 6.86668L12 2.58234ZM3.53846 8.14356L11.2308 12.4211V20.9898L3.53846 16.7122V8.14356ZM12.7692 20.9898V12.4211L20.4615 8.14356V16.7122L12.7692 20.9898Z'
        fill='black'
      />
      <rect
        x='9.25'
        y='14.75'
        width='5.5'
        height='5.5'
        transform='rotate(-90 9.25 14.75)'
        fill='#0F2EFF'
        stroke='white'
        strokeWidth='1.5'
      />
    </svg>
  );
};

export const CurveIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect x='5.10254' y='19' width='3' height='3' stroke='black' />
      <rect x='17.1025' y='3' width='3' height='3' stroke='black' />
      <path
        d='M6.60254 18.5C6.60254 10.7 18.6025 14.9 18.6025 6.5'
        stroke='black'
      />
    </svg>
  );
};

export const MeasureProjectedIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx='12.6025' cy='12.5' r='9.5' stroke='black' />
      <path
        d='M13.1548 8.5C15.0508 8.5 15.9868 9.592 15.9868 11.128C15.9868 12.664 15.0508 13.756 13.1548 13.756H10.6108V17.044H9.60278V8.5H13.1548ZM13.1548 12.844C14.3548 12.844 14.9428 12.208 14.9428 11.128C14.9428 10.048 14.3548 9.412 13.1548 9.412H10.6108V12.844H13.1548Z'
        fill='black'
      />
    </svg>
  );
};

export const TargetCenterIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx='12.6025' cy='12.5' r='6.5' stroke='black' />
      <circle cx='12.6025' cy='12.5' r='3' fill='#0F2EFF' />
    </svg>
  );
};

export const MeasureTwoPointsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect x='19.1025' y='19' width='3' height='3' rx='1.5' stroke='black' />
      <rect x='3.10254' y='3' width='3' height='3' rx='1.5' stroke='black' />
      <path d='M6.45605 6.64648L18.4561 18.6465' stroke='black' />
      <path d='M19.1025 15V19H15.1025' stroke='black' />
      <path d='M6.10254 10L6.10254 6L10.1025 6' stroke='black' />
    </svg>
  );
};

export const TargetFaceIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='23'
      height='23'
      viewBox='0 0 23 23'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect
        x='1.30965'
        y='11.5'
        width='14.5563'
        height='14.5563'
        transform='rotate(-45 1.30965 11.5)'
        stroke='black'
      />
      <path
        d='M1.03467 11.303L14.8625 13.0315M14.8625 13.0315L11.8377 21.2418M14.8625 13.0315L11.8377 1.36426M14.8625 13.0315L21.7765 11.303'
        stroke='black'
      />
      <rect
        x='7.38062'
        y='7.27808'
        width='3'
        height='3'
        rx='1.5'
        fill='#0F2EFF'
      />
    </svg>
  );
};

export const GeometryIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_5562_25327)'>
        <path
          d='M15.4992 8.0003V8.00039C15.4992 12.1418 12.1418 15.5 7.99961 15.5H0.5V7.99961C0.5 3.85821 3.85821 0.5 7.99961 0.5C12.1418 0.5 15.5 3.85821 15.4992 8.0003Z'
          fill='white'
          stroke='black'
          className={props.className}
        />
        <circle
          cx='8'
          cy='8'
          r='3.33333'
          fill='white'
          stroke='black'
          className={props.className}
          strokeWidth='1.33333'
        />
      </g>
      <defs>
        <clipPath id='clip0_5562_25327'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const PartIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_5562_25330)'>
        <path
          d='M15.4992 8.0003V8.00039C15.4992 12.1418 12.1418 15.5 7.99961 15.5H0.5V7.99961C0.5 3.85821 3.85821 0.5 7.99961 0.5C12.1418 0.5 15.5 3.85821 15.4992 8.0003Z'
          fill='white'
          stroke='black'
          className={props.className}
        />
        <path
          d='M11.3664 5.94264L8.13567 4.03709C8.09449 4.0128 8.04767 4 8 4C7.95233 4 7.90551 4.0128 7.86433 4.03709L4.63357 5.94264C4.59292 5.96661 4.5592 6.00094 4.53576 6.0422C4.51233 6.08346 4.5 6.1302 4.5 6.17778V9.98888C4.5 10.0365 4.51233 10.0832 4.53576 10.1245C4.5592 10.1657 4.59292 10.2001 4.63357 10.224L7.86433 12.1296C7.90551 12.1539 7.95233 12.1667 8 12.1667C8.04767 12.1667 8.09449 12.1539 8.13567 12.1296L11.3664 10.224C11.4071 10.2001 11.4408 10.1657 11.4642 10.1245C11.4877 10.0832 11.5 10.0365 11.5 9.98888V6.17778C11.5 6.1302 11.4877 6.08346 11.4642 6.0422C11.4408 6.00094 11.4071 5.96661 11.3664 5.94264ZM8 4.58738L10.6965 6.17778L8 7.76818L5.30349 6.17778L8 4.58738ZM5.03846 6.65177L7.73077 8.23964V11.4204L5.03846 9.83257V6.65177ZM8.26923 11.4204V8.23964L10.9615 6.65177V9.83257L8.26923 11.4204Z'
          fill='black'
          stroke='black'
          strokeWidth='0.5'
          className={props.className}
        />
      </g>
      <defs>
        <clipPath id='clip0_5562_25330'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ModelIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_5562_24180)'>
        <path d='M6.5 2H2V6.505H3V3H6.5V2Z' fill='black' />
        <path
          d='M14.7451 6.56003L10.2451 4.06003C10.1691 4.01615 10.0829 3.99304 9.9951 3.99304C9.90733 3.99304 9.82111 4.01615 9.7451 4.06003L5.2451 6.56003C5.16898 6.60513 5.1062 6.66963 5.06316 6.74693C5.02011 6.82423 4.99835 6.91157 5.0001 7.00003V12C5.00075 12.0891 5.02519 12.1764 5.0709 12.2529C5.11661 12.3294 5.18193 12.3923 5.2601 12.435L9.7601 14.935C9.83335 14.9766 9.9159 14.9989 10.0001 15C10.0858 14.9987 10.17 14.9764 10.2451 14.935L14.7451 12.435C14.8223 12.3916 14.8866 12.3285 14.9314 12.252C14.9763 12.1756 14.9999 12.0886 15.0001 12V7.00003C15.0008 6.91058 14.9776 6.82258 14.9327 6.74519C14.8879 6.6678 14.8231 6.60386 14.7451 6.56003ZM9.5001 13.65L6.0001 11.705V7.84503L9.5001 9.79003V13.65ZM10.0001 8.92503L6.5301 7.00003L10.0001 5.07003L13.4701 7.00003L10.0001 8.92503ZM14.0001 11.705L10.5001 13.65V9.79003L14.0001 7.84503V11.705Z'
          fill='black'
        />
      </g>
      <defs>
        <clipPath id='clip0_5562_24180'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DeleteIcon = ({ fill, ...rest }: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='red'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <g clipPath='url(#clip0_5562_26381)'>
        <path d='M7 6H6V12H7V6Z' fill={fillColor} />
        <path d='M10 6H9V12H10V6Z' fill={fillColor} />
        <path
          d='M2 3V4H3V14C3 14.2652 3.10536 14.5196 3.29289 14.7071C3.48043 14.8946 3.73478 15 4 15H12C12.2652 15 12.5196 14.8946 12.7071 14.7071C12.8946 14.5196 13 14.2652 13 14V4H14V3H2ZM4 14V4H12V14H4Z'
          fill={fillColor}
        />
        <path d='M10 1H6V2H10V1Z' fill={fillColor} />
      </g>
      <defs>
        <clipPath id='clip0_5562_26381'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ComparisonColorIcon = ({
  fill,
  ...rest
}: SVGProps<SVGSVGElement>) => {
  const fillColor = fill || 'black';

  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <rect x='0.5' y='0.5' width='15' height='15' rx='2' stroke={fillColor} />
      <path
        d='M2.5 0.5H14.25L0.5 14.25V2.5C0.5 1.39543 1.39543 0.5 2.5 0.5Z'
        fill={fillColor}
        stroke={fillColor}
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const MeasureAxisIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='25'
      height='25'
      viewBox='0 0 25 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect
        x='11.1025'
        y='3'
        width='3'
        height='19'
        rx='1.5'
        stroke='black'
        className={props.className}
      />
      <path
        d='M14.3125 9.5437C19.0207 9.78707 22.6025 11.0181 22.6025 12.5C22.6025 14.1569 18.1254 15.5 12.6025 15.5C7.07969 15.5 2.60254 14.1569 2.60254 12.5C2.60254 11.131 5.65941 9.97609 9.83722 9.61619'
        stroke='black'
        className={props.className}
      />
      <path
        d='M8.05328 12.0435L10.0533 9.54346L8.05328 7.04346'
        stroke='black'
        className={props.className}
      />
    </svg>
  );
};

export const OverlayIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='17'
      height='22'
      viewBox='0 0 17 22'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path d='M7 4H1V18H7V4Z' fill='black' stroke='black' />
      <path d='M10.2461 4H16.2461V18H10.2461' stroke='black' />
      <mask
        id='mask0_6015_17937'
        maskUnits='userSpaceOnUse'
        x='10'
        y='4'
        width='7'
        height='14'
      >
        <rect
          x='10.2461'
          y='18'
          width='14'
          height='6'
          transform='rotate(-90 10.2461 18)'
          fill='#D9D9D9'
        />
      </mask>
      <g mask='url(#mask0_6015_17937)'>
        <path d='M8.7168 6.04793L16.3855 14.9947' stroke='black' />
        <path d='M10.1309 4.39819L16.2896 11.5834' stroke='black' />
        <path d='M11.5449 2.74846L16.4947 8.52316' stroke='black' />
        <path d='M16.2924 4.98716L15.2305 3.74821' stroke='black' />
        <path d='M7.37695 7.7404L16.1709 18' stroke='black' />
        <path d='M5.92578 9.35539L13.5 18.1919' stroke='black' />
      </g>
      <line
        x1='8.87305'
        x2='8.87305'
        y2='22'
        stroke='black'
        strokeDasharray='4 2'
      />
    </svg>
  );
};

export const RightIcon = ({ stroke, ...rest }: SVGProps<SVGSVGElement>) => {
  const strokeColor = stroke || '#0F2EFF';

  return (
    <svg
      width='12'
      height='10'
      viewBox='0 0 12 10'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M0.166748 5C3.837 4.88889 11.1775 5 11.1775 5M11.1775 5L6.91527 1M11.1775 5L6.91527 9'
        stroke={strokeColor}
      />
    </svg>
  );
};

export const CylinderIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='14'
      height='16'
      viewBox='0 0 14 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <ellipse cx='7' cy='12.6836' rx='6' ry='2' stroke='#C5C5C5' />
      <path d='M13 3.35059V12.6839' stroke='#777777' />
      <path d='M1 3.35059V12.6839' stroke='#777777' />
      <ellipse cx='7' cy='3.35059' rx='6' ry='2' stroke='#777777' />
      <path
        d='M13 12.6836C13 13.7882 10.3137 14.6836 7 14.6836C3.68629 14.6836 1 13.7882 1 12.6836'
        stroke='#777777'
      />
    </svg>
  );
};

export const ConeIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='14'
      height='15'
      viewBox='0 0 14 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <ellipse cx='7' cy='11.3049' rx='6' ry='2.21216' stroke='#C5C5C5' />
      <path
        d='M7 13.5167C10.3137 13.5167 13 12.4881 13 11.2193C13 9.89433 7 0.51709 7 0.51709C7 0.51709 1 10.2205 1 11.2193C1 12.4881 3.68629 13.5167 7 13.5167Z'
        stroke='#777777'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const NurbsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <rect x='12' y='3.01709' width='2' height='2' fill='#777777' />
      <rect x='3' y='12.0171' width='2' height='2' fill='#777777' />
      <line x1='13' y1='4.01709' x2='3' y2='4.01709' stroke='#C5C5C5' />
      <path
        d='M13 4.01709H10C6.68629 4.01709 4 6.70338 4 10.0171V13.0171'
        stroke='#777777'
      />
      <rect x='2' y='3.01709' width='2' height='2' fill='#777777' />
    </svg>
  );
};

export const SphereIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='14'
      height='14'
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <ellipse cx='7' cy='7.01709' rx='6' ry='2' stroke='#C5C5C5' />
      <path
        d='M13 7.01709C13 8.12166 10.3137 9.01709 7 9.01709C3.68629 9.01709 1 8.12166 1 7.01709'
        stroke='#777777'
      />
      <circle cx='7' cy='7.01709' r='6' stroke='#777777' />
    </svg>
  );
};

export const TorusIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='14'
      height='12'
      viewBox='0 0 14 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <ellipse cx='7' cy='6.01709' rx='6' ry='5' stroke='#777777' />
      <ellipse cx='7' cy='6.01709' rx='3' ry='2' stroke='#777777' />
      <ellipse
        opacity='0.4'
        cx='11.5'
        cy='6.01709'
        rx='1.5'
        ry='1'
        stroke='#777777'
      />
      <path
        d='M13 6.01709C13 5.46481 12.3284 5.01709 11.5 5.01709C10.6716 5.01709 10 5.46481 10 6.01709'
        stroke='#777777'
      />
    </svg>
  );
};

export const FacesIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_5938_33761)'>
        <path
          d='M14.6622 4.17241L8.50839 0.750199C8.42996 0.706579 8.34078 0.683594 8.24998 0.683594C8.15918 0.683594 8.07 0.706579 7.99157 0.750199L1.83772 4.17241C1.7603 4.21547 1.69607 4.27712 1.65144 4.35121C1.6068 4.42531 1.58331 4.50927 1.58331 4.59471V11.4391C1.58331 11.5246 1.6068 11.6085 1.65144 11.6826C1.69607 11.7567 1.7603 11.8184 1.83772 11.8614L7.99157 15.2837C8.07 15.3273 8.15918 15.3503 8.24998 15.3503C8.34078 15.3503 8.42996 15.3273 8.50839 15.2837L14.6622 11.8614C14.7397 11.8184 14.8039 11.7567 14.8485 11.6826C14.8932 11.6085 14.9166 11.5246 14.9166 11.4391V4.59471C14.9166 4.50927 14.8932 4.42531 14.8485 4.35121C14.8039 4.27712 14.7397 4.21547 14.6622 4.17241ZM8.24998 1.73849L13.3862 4.59471L8.24998 7.45094L3.11377 4.59471L8.24998 1.73849ZM2.60895 5.44596L7.73716 8.29765V14.0101L2.60895 11.1584V5.44596ZM8.7628 14.0101V8.29765L13.891 5.44596V11.1584L8.7628 14.0101Z'
          fill='#8B8B8B'
        />
        <path
          d='M14.4197 11.4072V4.62988L8.24381 8.00394L8.24384 14.8692L14.4197 11.4072Z'
          fill='black'
          stroke='black'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_5938_33761'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(0.25 0.0170898)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const EdgeIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='17'
      height='17'
      viewBox='0 0 17 17'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_5938_33765)'>
        <path
          d='M14.6622 4.17241L8.50839 0.750199C8.42996 0.706579 8.34078 0.683594 8.24998 0.683594C8.15918 0.683594 8.07 0.706579 7.99157 0.750199L1.83772 4.17241C1.7603 4.21547 1.69607 4.27712 1.65144 4.35121C1.6068 4.42531 1.58331 4.50927 1.58331 4.59471V11.4391C1.58331 11.5246 1.6068 11.6085 1.65144 11.6826C1.69607 11.7567 1.7603 11.8184 1.83772 11.8614L7.99157 15.2837C8.07 15.3273 8.15918 15.3503 8.24998 15.3503C8.34078 15.3503 8.42996 15.3273 8.50839 15.2837L14.6622 11.8614C14.7397 11.8184 14.8039 11.7567 14.8485 11.6826C14.8932 11.6085 14.9166 11.5246 14.9166 11.4391V4.59471C14.9166 4.50927 14.8932 4.42531 14.8485 4.35121C14.8039 4.27712 14.7397 4.21547 14.6622 4.17241ZM8.24998 1.73849L13.3862 4.59471L8.24998 7.45094L3.11377 4.59471L8.24998 1.73849ZM2.60895 5.44596L7.73716 8.29765V14.0101L2.60895 11.1584V5.44596ZM8.7628 14.0101V8.29765L13.891 5.44596V11.1584L8.7628 14.0101Z'
          fill='#8B8B8B'
        />
        <path
          d='M14.1764 4.72803L8.39917 7.89746'
          stroke='black'
          strokeWidth='1.5'
          strokeLinecap='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_5938_33765'>
          <rect
            width='16'
            height='16'
            fill='white'
            transform='translate(0.25 0.0170898)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const DisplayIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='16'
      height='13'
      viewBox='0 0 16 13'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M3.904 0.666626H12.0396L14.6667 4.56024L7.97179 12L1.33337 4.56024L3.904 0.666626Z'
        stroke='white'
        strokeLinejoin='round'
      />
      <path
        d='M5.95206 0.666626H10.0199L11.3334 4.56024L7.98596 12L4.66675 4.56024L5.95206 0.666626Z'
        stroke='white'
        strokeLinejoin='round'
      />
      <line
        x1='14.6667'
        y1='4.83325'
        x2='1.33341'
        y2='4.83325'
        stroke='white'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const MouseIcon = (props: SVGProps<SVGSVGElement>) => {
  const strokeColor = props.stroke || 'white';
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_6137_27005)'>
        <rect
          x='3.4646'
          y='2.17126'
          width='8'
          height='12.0098'
          rx='3'
          stroke={strokeColor}
        />
        <line
          x1='3.4646'
          y1='6.67615'
          x2='11.4646'
          y2='6.67615'
          stroke={strokeColor}
        />
        <line
          x1='7.5'
          y1='7.17633'
          x2='7.5'
          y2='1.81897'
          stroke={strokeColor}
        />
      </g>
      <defs>
        <clipPath id='clip0_6137_27005'>
          <rect width='16' height='16' fill={strokeColor} />
        </clipPath>
      </defs>
    </svg>
  );
};

export const CubeFileIcon = (props: SVGProps<SVGSVGElement>) => {
  const fillColor = props.fill || '#1F1F1F';

  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g clipPath='url(#clip0_3947_14914)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M10.3231 0.916752L18.0154 5.19452C18.1122 5.24834 18.1925 5.3254 18.2483 5.41802C18.3041 5.51064 18.3334 5.61559 18.3334 5.7224V11.2726H17.0514V6.78646L10.6411 10.3511V17.4916L10.6495 17.487V18.9021L10.3231 19.0836C10.2251 19.1381 10.1136 19.1668 10.0001 19.1668C9.88658 19.1668 9.77511 19.1381 9.67707 19.0836L1.98476 14.8058C1.88799 14.752 1.8077 14.6749 1.7519 14.5823C1.6961 14.4897 1.66674 14.3847 1.66675 14.2779V5.7224C1.66674 5.61559 1.6961 5.51064 1.7519 5.41802C1.8077 5.3254 1.88799 5.24834 1.98476 5.19452L9.67707 0.916752C9.77511 0.862227 9.88658 0.833496 10.0001 0.833496C10.1136 0.833496 10.2251 0.862227 10.3231 0.916752ZM16.4203 5.7224L10.0001 2.15211L3.57983 5.7224L10.0001 9.29268L16.4203 5.7224ZM9.35906 10.3511L2.9488 6.78646V13.927L9.35906 17.4916V10.3511Z'
          fill={fillColor}
        />
        <path d='M19.7831 12.5H11.8665V13.75H19.7831V12.5Z' fill={fillColor} />
        <path d='M19.7831 15H11.8665V16.25H19.7831V15Z' fill={fillColor} />
        <path d='M15.6165 17.5H11.8665V18.75H15.6165V17.5Z' fill={fillColor} />
      </g>
      <defs>
        <clipPath id='clip0_3947_14914'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};
